import { Component, OnInit, OnDestroy, HostListener, ViewContainerRef, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ADKDetailsViewModel } from '../../models/adk-details-view.model';
import { SubscriptionApiResponse, PerpetualApiResponse, MnpIdAipiResponse, ApiResponse } from '../../models/api-response.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ManageService } from '../../services/manage.service';
import { CSPSubscriptions, CSPDetailsItemViewModel, GetCSPSubscription, CSPModifySubscriptionViewModel, CSPModifySubscriptionResponse, GetCSPSubscriptionActions, CSPItemListViewModel, CSPUsageDetailsViewModel, CSPPerpetualItemViewModel, CSPPerpetualItem, CSPPerpetualItemsViewModel, CSPPerpetualModifyViewModel, CSPPerpetualDownloadOptionsViewModel, ManagementLink, UsageDetails, CSPCustomerEntitlementsViewModel, CSPTenantUser, ProductTerm, KeyValuePair, AddOnKeyValuePair, SubscriptionAction, AdminRelationship, IAMPOrdersByCustomerResponse } from '../../models/csp.model';
import { CommonService } from '../../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnuityItemsViewModel, AnnuityViewModel } from '../../models/annuity-view.model';
import { MicrosoftCloudAgreementComponent } from '../../popup-collection/microsoft-cloud-agreement/microsoft-cloud-agreement.component';
import { ConfirmSubscriptionComponent } from '../../popup-collection/confirm-subscription/confirm-subscription.component';
import { FinishSubscriptionComponent } from '../../popup-collection/finish-subscription/finish-subscription.component';
import { ConfirmSoftwareComponent } from '../../popup-collection/confirm-software/confirm-software.component';
import { FinishSoftwareComponent } from '../../popup-collection/finish-software/finish-software.component';
import { ConfirmAzureRiComponent } from '../../popup-collection/confirm-azure-ri/confirm-azure-ri.component';
import { FinishAzureRiComponent } from '../../popup-collection/finish-azure-ri/finish-azure-ri.component';
// tslint:disable-next-line:import-blacklist
import { Subject, Observable } from 'rxjs';
import { CmsStudioService } from '../../cms/cms-studio.service';
import { Cms } from '../../cms/models/cms.model';
import { AssociationInvitationComponent } from '../../popup-collection/association-invitation/association-invitation.component';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel, CustomerPaymentsOutput } from '../../models/account-ledger.model';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { skip, switchMap, takeUntil, tap, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { NgProgressService } from '../../services/ngProgress.service';
import { ConfirmNCESubscriptionComponent } from '../../popup-collection/confirm-nce-subscription/confirm-nce-subscription.component';
import { differenceInDays, addDays, getDaysInMonth, isBefore, format } from 'date-fns';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MigrateToNCEComponent } from '../../popup-collection/migrate-to-nce/migrate-to-nce.component';
import { FileService } from '../../services/file.service';
import { CSPTenantManagementComponent } from './csp-tenant-management/csp-tenant-management.component';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { CustomerService } from '../../services/customer.service';
import { DDCustomer } from '../../models/customer.model';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-manage-csp-details',
  templateUrl: './manage-cspdetails.component.html',
  styleUrls: ['./manage-cspdetails.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageCspDetailsComponent implements OnInit, OnDestroy {

  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;
  @ViewChild("cspTenantManagement", { static: false }) cspTenantManagement: CSPTenantManagementComponent;
  @ViewChild("tenantManagementExpansionPanel", { static: false }) tenantManagementExpansionPanel: ElementRef;
  @ViewChild("RIExpansionPanel", { static: false }) RIExpansionPanel: ElementRef;
  @ViewChild("softwareExpansionPanel", { static: false }) softwareExpansionPanel: ElementRef;
  @ViewChild(MatSort) sort: MatSort;

  title = 'Manage Details';
  subscriptionResponse: SubscriptionApiResponse;
  agreement: FormGroup;
  tenantId: string;
  programType: string;
  agreement_validation_messages: any = ManageService.agreement_validation_messages;
  currentUserModel: CurrentUserModel;
  public subscriptions: CSPSubscriptions[];
  public nceSubs: CSPSubscriptions[];
  public licenseSubs: CSPSubscriptions[];
  public azureUsageSubs: CSPSubscriptions[];

  public nceSubsDataSource: MatTableDataSource<CSPSubscriptions>;
  public NCESubTableDisplayedColumns: string[] = ['desc', 'qty', 'price', 'rrp', 'autoRenewal', 'status', 'actions'];
  NCESortedData: CSPSubscriptions[] = [];

  subscriptionsPendingChange: GetCSPSubscription[] = [];
  subscriptionActions: GetCSPSubscriptionActions[];
  subscriptionActionExist: GetCSPSubscriptionActions[];
  cSPDetailsItemViewModel: CSPDetailsItemViewModel;
  details: ADKDetailsViewModel;

  public pendingTotal = 0;

  activeTotal = '0';
  totalPriceChange = 0;
  togglePriceChange = 0;
  totalPerpetualPendingPrice = 0;
  totalAzureRiPendingPrice = 0;
  totalSoftwareSubscriptionPendingPrice = 0;
  originalBaseQty: KeyValuePair[];
  originalAddonQty: AddOnKeyValuePair[];
  originalBaseActive: KeyValuePair[];
  originalAddonActive: AddOnKeyValuePair[];
  originalAddonMPNId: AddOnKeyValuePair[];
  pendingConfirmStatus = false;
  pendingRowConfirmStatus = false;
  confirmSubscriptions: CSPModifySubscriptionViewModel[];
  poReference = '';
  perpetualPoReference = '';
  azureRiPoReference = '';
  softwareSubscriptionPoReference = '';
  finishSubscriptions: CSPModifySubscriptionResponse[];
  changeSubscriptionAmount: number;
  confirmBaseSubscription: CSPModifySubscriptionViewModel;
  confirmAddonSubscription: CSPModifySubscriptionViewModel;
  confirmAnnuityItemSubscription: CSPModifySubscriptionViewModel;
  annuityItems: AnnuityItemsViewModel[];
  annuityItemsFilter: AnnuityItemsViewModel[];
  annuityItemsPendingList: AnnuityItemsViewModel[] = [];
  selectedSubscriptionType: string;
  searchAnnuity = '';
  searchSoftware = '';

  // filter about vars
  public searchSubscription = '';
  public searchAzureUsageSubscription = '';
  public selectedStatus: string[] = [];
  public selectedRenewalOptions = null;
  public azureUsageSubsSelectedStatus: string[] = [];
  public searchStatusList: string[] = [];
  public azureUsageSearchStatusList: string[] = [];


  cspItemListView: CSPItemListViewModel;
  mpnIdSelect = '';
  mpnIdAddonSelect = '';
  azureRiMpnIdSelect = '';
  softwareSubscriptionMpnIdSelect = '';
  mpnList: string[];
  cspPartnerCenterUsage: CSPUsageDetailsViewModel[] = [];
  totalPrice: number;
  azureRIItemsPendingList: CSPPerpetualItemsViewModel[] = [];
  softwareSubscriptionPendingList: CSPPerpetualItemsViewModel[] = [];
  cspPerpetualItems: CSPPerpetualItemsViewModel[] = [];
  cspPerpetualItemsFilter: CSPPerpetualItemsViewModel[] = [];
  cspPerpetualItemsPending: CSPPerpetualItemsViewModel[] = [];

  // CSPCustomerEntitlementsViewModel
  cspSoftwareItems: CSPCustomerEntitlementsViewModel[] = [];
  cspReservedInstanceItems: CSPCustomerEntitlementsViewModel[] = [];


  continueSavePerpetualItem: CSPPerpetualModifyViewModel;
  continueSavePerpetualList: CSPPerpetualModifyViewModel[] = [];
  continueSaveAzureRiItem: CSPPerpetualModifyViewModel;
  continueSaveAzureRiList: CSPPerpetualModifyViewModel[] = [];
  continueSaveSoftwareSubscriptionItem: CSPPerpetualModifyViewModel;
  continueSaveSoftwareSubscriptionList: CSPPerpetualModifyViewModel[] = [];
  perpetualApiResponse: PerpetualApiResponse;
  azureRiApiResponse: PerpetualApiResponse;
  softwareSubscriptionApiResponse: PerpetualApiResponse;
  cspAzureRiAddItems: CSPPerpetualItemsViewModel[] = [];
  cspAzureRiAddItemsFilter: CSPPerpetualItemsViewModel[] = [];
  searchAzureRi = '';
  perpetualDownloadOptions: CSPPerpetualDownloadOptionsViewModel;
  softwareSubscriptionAddItems: CSPPerpetualItemsViewModel[] = [];
  softwareSubscriptionAddItemsFilter: CSPPerpetualItemsViewModel[] = [];
  searchSoftwareSubscription: string;
  languageCode: string;
  selectedAzureRi: string;
  purchase: string;
  usageDetails: UsageDetails[];
  headerLink: ManagementLink;
  selectedTabIndex = 0;
  statusList: any = [{ name: 'ACTIVE', value: 'active' }, { name: 'PENDING CHANGES', value: 'pending' }, { name: 'SUSPEND', value: 'suspend' }];
  renewalOptionsList: any = [{ name: 'Auto-Renew On', value: 'on' }, { name: 'Auto-Renew Off', value: 'off' }, { name: 'Schedule Change Pending', value: 'pending' }];
  
  cspPartnerCenterUsageLoadingStatus = true;
  selectMonthlyPayment = false;
  programName: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  checkMpnId: Boolean = false;
  isToCheckOwnerEmail: Boolean = false;
  checkEmail: Boolean = true;
  showMpnIdloading: Boolean;
  showEmailloading: Boolean;
  isToCheckEditMNPId: Boolean = false;
  cms = new Cms();
  viewCms = new Cms();
  viewNavIndex: number;
  showAzurePlan: Boolean = false;
  isMCASigned: Boolean = false;
  checkExistingAzurePlan = false;
  isAzureUpgradeInProgress: Boolean;
  showAzureButtonloading = false;
  tempMPNIdArray: string[] = [];
  closeResult: string;
  azurePopup: NgbModalRef;
  azureUpgradeNotHiden = true;
  showAzureButtonUpgradeloading = false;
  hasPendingAzureProduct = false;
  paymentMethod: CustomerPaymentsOutput = null;
  digitalWalletId = '';
  isStaffAccount = false;
  status: boolean;
  tab: string;
  isSubscriptionResponseLoading = false;
  isCSPItemLoading = true;
  isTenantManagementLoading = false;
  hasZeroQtySub = false;
  hasSubPending = false;
  public hasLegacy = false;
  GetMSCloudAgreementStatus: Subject<string> = new Subject<string>();
  GetMSCloudAgreementStatus$: Observable<SubscriptionApiResponse>;

  hasNCESub = false;
  public annuity: AnnuityViewModel;

  // New Commerce Experience
  nceAddonTitle = "NCE ADD-ON";
  NoMPNText = '';
  showCancellingLoading = false;
  cancelDescText = 'Cancel In Progress';
  checkingSoftwareSubscriptionIndex = -1;
  public checkingAzureRIIndex = -1;
  private nceRenewalPendingList: SubscriptionAction[];
  public azureRIPurchaseRightStatus: string;
  public invalidQtyInput = false;

  public tenantManagementFormGroup = this.fb.group({
    days: [7],
    title: ['1']
  })

  renewalType = '';

  // variables for whether panels are open
  public panelEndUserDetailsOpen = false;
  public panelTenantManagementOpen = false;
  public panelEndUserPortalManagementOpen = false;
  public panelNCESubscriptionOpen = false;
  public panelLicenseSubscriptionOpen = false;
  public panelAzureUsageSubscriptionOpen = false;
  public panelReservedInstanceOpen = false;
  public panelSoftwareOpen = false;
  public panelOrderHistoryOpen = false;
  public tenantManagementDataLoaded = false;
  private RITabOpened = false;
  private softwareTabOpened = false;
  private orderHistoryTabOpened = false;
  public orderHistoryLoading = false;
  public loadCSPSoftware = true;
  public loadCSPAzureri = true;
  private orderHistoryPage = 1;
  public orderHistory: IAMPOrdersByCustomerResponse[] = []
  public orderHistoryTableDataSource = new MatTableDataSource(this.orderHistory);
  public orderHistoryDateFromText: string = '';
  public orderHistoryDisplayedColumns = ['orderDate', 'orderType', 'stockCode', 'stockDescription', 'qty']
  public expandedElement: any = null;

  constructor(
    private manageService: ManageService,
    private customerService: CustomerService,
    public cs: CommonService,
    public ngProgress: NgProgressService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private cmsserivce: CmsStudioService,
    private authService: AuthService,
    private modalService: NgbModal,
    private fileService: FileService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
  ) {
    this.NoMPNText = cs.NoMPNText;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    if ((this.annuityItemsPendingList && this.annuityItemsPendingList.length) ||
      (this.softwareSubscriptionPendingList && this.softwareSubscriptionPendingList.length) ||
      (this.cspPerpetualItemsPending && this.cspPerpetualItemsPending.length) ||
      (this.azureRIItemsPendingList && this.azureRIItemsPendingList.length) ||
      this.hasSubPending) {
      return false;
    } else {
      return true;
    }
  }

  async ngAfterViewInit() {
    // Initialize the sort after view is initialized
    if (this.nceSubsDataSource) {
      this.nceSubsDataSource.sort = this.sort;
    }
    await this.cs.waitForElm('#levelOne');
    if (
      !$('#upgradeSubscription').length &&
      !$('#confirmUpgrade').length &&
      !$('#editenduser').length &&
      !$('#addProduct').length
    ) {
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
    }
  }

  ngOnInit() {
    this.ngProgress.start();
    this.originalBaseQty = [];
    this.originalAddonQty = [];
    this.originalBaseActive = [];
    this.originalAddonActive = [];
    this.originalAddonMPNId = [];
    this.subscriptionActions = [];
    this.changeSubscriptionAmount = this.cs.toNumber(this.cs.readCookie('ChangeSubscriptionAmount'));
    this.cspPartnerCenterUsageLoadingStatus = true;
    this.checkMpnId = true;
    this.checkEmail = false;

    $('.activesuspend').removeAttr('checked');

    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.showAzurePlan = false;
      this.isAzureUpgradeInProgress = false;
      this.hasPendingAzureProduct = false;

      setTimeout(() => {
        this.ngAfterViewInit();
      }, 100)
    });

    this.authService.getLoginInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: CurrentUserModel) => {
        this.currentUserModel = res;
      }, (error: any) => {
        console.error(error);
      });

    this.manageService.currentCSPSoftware
      .pipe(takeUntil(this.ngUnsubscribe), switchMap(subscription =>
        this.manageService.GetNCERenewStatus(this.tenantId, subscription.subscriptionId).pipe(map((sub: string) => {
          const result = JSON.parse(sub);
          if (subscription?.stockCode) {
            result.stockCode = subscription.stockCode;
          }
          return result;
        }))
      ))
      .subscribe(val => {
        if (!this.cs.isEmpty(val)) {
          this.checkingSoftwareSubscriptionIndex = -1;
          this.router.navigate(['ManageLicenseSubscriotion/SubscriptionDetails/', { sof: val.id }], { relativeTo: this.activatedRoute });
          this.manageService.sendCurrentSoftwareSubscription(val);
        } else {
          this.cs.implementToast("No options available to manage this software subscription!", "Warning");
          this.checkingSoftwareSubscriptionIndex = -1;
        }
      });

    this.manageService.currentReservedInstance
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(val => {
        if (!this.cs.isEmpty(val)) {
          this.checkingSoftwareSubscriptionIndex = -1;
          this.router.navigate(['ManageReservedInstance/', {}], { relativeTo: this.activatedRoute });
          this.manageService.sendCurrentSoftwareSubscription(val);
        } else {
          this.cs.implementToast("No options available to manage this reserved instance subscription!", "Warning");
          this.checkingSoftwareSubscriptionIndex = -1;
        }
      });

    this.manageService.currentSelectedTabIndex.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: number) => {
      this.selectedTabIndex = res;
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
    },
      (error: any) => {
        console.error(error);
      });


    this.manageService.currentConfigureEndUserStatus.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      this.status = res.status;
      this.tab = res.tab;
    });

    this.GetMSCloudAgreementStatus$ = this.GetMSCloudAgreementStatus.pipe(takeUntil(this.ngUnsubscribe), switchMap(tenantId => {
      return this.manageService.GetMSCloudAgreementStatus(tenantId).pipe(takeUntil(this.ngUnsubscribe), tap((res: SubscriptionApiResponse) => {
        this.subscriptionResponse = res;
        if (this.subscriptionResponse.status === 'Fail' && this.subscriptionResponse.agreementMetaData) {
          const dialogRef = this.dialog.open(MicrosoftCloudAgreementComponent, {
            width: '630px',
            height: '470px',
            data: {
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              link: this.subscriptionResponse.agreementMetaData.agreementLink,
              status: this.subscriptionResponse.status,
              tenantId: this.tenantId,
              hdnAgreementVersion: this.subscriptionResponse.agreementMetaData.templateId,
              type: 'BACK'
            },
            panelClass: 'mat-dialog-wrapper',
            disableClose: true
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.manageService.GetMSCloudAgreementStatus(this.tenantId)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((resp: SubscriptionApiResponse) => {
                  this.isSubscriptionResponseLoading = false;
                  this.subscriptionResponse = resp;
                },
                  (error: any) => {
                    console.error(error);
                  });
            }
          });
        } else if (this.subscriptionResponse.status === 'MCA') {
          const dialogRef = this.dialog.open(MicrosoftCloudAgreementComponent, {
            width: '630px',
            height: '470px',
            data: {
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              link: this.subscriptionResponse.agreementMetaData.agreementLink,
              status: this.subscriptionResponse.status,
              tenantId: this.tenantId,
              hdnAgreementVersion: this.subscriptionResponse.agreementMetaData.templateId,
              type: 'CLOSE'
            },
            panelClass: 'mat-dialog-wrapper',
            disableClose: true
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.manageService.GetMSCloudAgreementStatus(this.tenantId).subscribe((resp: SubscriptionApiResponse) => {
                this.isSubscriptionResponseLoading = false;
                this.subscriptionResponse = resp;
              },
                (error: any) => {
                  console.error(error);
                });
            }
          });
        } else if (this.subscriptionResponse.status === 'Fail') {
          this.isSubscriptionResponseLoading = false;
          this.cs.implementToast('Error in Microsoft Agreement API', 'Error');
        }
        else {
          // mca signed already
          this.isMCASigned = true;
          this.isSubscriptionResponseLoading = false;
        }
      }))
    }))
    this.GetMSCloudAgreementStatus$.subscribe();

    this.activatedRoute.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(param => {

      this.tenantId = param.get('tenantId');

      this.manageService.currentAnnuityList.pipe(takeUntil(this.ngUnsubscribe)).subscribe(annuities => {
        if (annuities?.length) {
          this.annuity = annuities.find(a => a.annuityId === this.tenantId)
        }
      })

      // initialize all temp arrays
      this.originalBaseQty = [];
      this.originalAddonQty = [];
      this.originalBaseActive = [];
      this.originalAddonActive = [];
      this.originalAddonMPNId = [];
      this.subscriptionActions = [];
      // initial addonListPendingList
      //this.addonListPendingList = [];

      this.hasSubPending = false;
      this.hasZeroQtySub = false;

      this.manageService.monitorConfigureEndUserStatus({
        status: this.status,
        tenantId: this.tenantId,
        tab: this.tab
      });

      // this.manageService.monitorPendingAddon(this.addonListPendingList);
      // initial pending subscription
      this.annuityItemsPendingList = [];
      // this.manageService.monitorPendingSubscriptions(this.annuityItemsPendingList);
      // initial perpetual software
      this.cspPerpetualItemsPending = [];
      this.manageService.monitorPendingPerpetualItems(this.cspPerpetualItemsPending);
      // initial Azure
      this.azureRIItemsPendingList = [];
      // initial software
      this.softwareSubscriptionPendingList = [];
      // this.manageService.monitorPendingSoftware(this.softwareSubscriptionPendingList);

      this.pendingRowConfirmStatus = false;

      this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
        this.programType = value.get('programType');
        this.programName = value.get('programName');
      });


      this.activatedRoute.queryParamMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(query => {
        this.renewalType = query.get('type');
        switch (this.renewalType) {
          case 'RI':
            this.RITabClick();
            this.panelReservedInstanceOpen = true;
            this.getCSPItemsView(false);
            break;
          case 'SS':
            this.RITabClick();
            this.panelSoftwareOpen = true;
            this.getCSPItemsView(false);
            break;
        }
      });

      if (this.panelTenantManagementOpen) {
        this.cspTenantManagement.loadTenantManagement();
        this.cspTenantManagement.loadAdminRelationship();
      }
    },
      (error: any) => {
        console.error(error);
        this.isCSPItemLoading = false;
        this.panelNCESubscriptionOpen = true;
      });

    this.manageService.currentCSPTenantDetails.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (value) {
        this.details.customer = value;
      }
    });

    this.manageService.getOrRefreshSubscriptionOrderSubject.asObservable().pipe(takeUntil(this.ngUnsubscribe)).subscribe((refresh) => {
      this.manageService
        .getADKDetails(this.tenantId, 'CSP')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: ADKDetailsViewModel) => {
          if (res?.tenantId) {
            this.details = res;
            this.manageService.monitorDetailsChange(this.details);

            if (!refresh) {
              if (this.details?.customer?.out_status === 'SA') {
                const dialogRef = this.dialog.open(AssociationInvitationComponent, {
                  width: '630px',
                  disableClose: true,
                  panelClass: 'mat-dialog-wrapper',
                });
                dialogRef.afterClosed().subscribe(() => {
                  $('#levelOne').animate({ scrollLeft: 0 }, 400);
                  this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP');
                });
              }

              if (this.details?.customer?.out_status_desc === 'Active') {
                // clould agreement
                this.isSubscriptionResponseLoading = true;
                this.manageService.GetMSCloudAgreementStatus(this.tenantId)
                  .pipe(takeUntil(this.ngUnsubscribe))
                  .subscribe((res: SubscriptionApiResponse) => {
                    this.subscriptionResponse = res;
                    if (this.subscriptionResponse.status === 'Fail' && this.subscriptionResponse.agreementMetaData) {
                      const dialogRef = this.dialog.open(MicrosoftCloudAgreementComponent, {
                        width: '630px',
                        data: {
                          firstName: '',
                          lastName: '',
                          email: '',
                          phone: '',
                          link: this.subscriptionResponse.agreementMetaData.agreementLink,
                          status: this.subscriptionResponse.status,
                          tenantId: this.tenantId,
                          hdnAgreementVersion: this.subscriptionResponse.agreementMetaData.templateId,
                          type: 'BACK'
                        },
                        disableClose: true
                      });
                      dialogRef.afterClosed().subscribe(result => {
                        if (result) {
                          this.manageService.GetMSCloudAgreementStatus(this.tenantId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((resp: SubscriptionApiResponse) => {
                            if (resp.status == 'Success') {
                              this.isMCASigned = true;
                            }
                            this.isSubscriptionResponseLoading = false;
                            this.subscriptionResponse = resp;
                          },
                            (error: any) => {
                              console.error(error);
                            });
                        }
                      });
                    } else if (this.subscriptionResponse.status === 'MCA') {
                      const dialogRef = this.dialog.open(MicrosoftCloudAgreementComponent, {
                        width: '630px',
                        data: {
                          firstName: '',
                          lastName: '',
                          email: '',
                          phone: '',
                          link: this.subscriptionResponse.agreementMetaData.agreementLink,
                          status: this.subscriptionResponse.status,
                          tenantId: this.tenantId,
                          hdnAgreementVersion: this.subscriptionResponse.agreementMetaData.templateId,
                          type: 'CLOSE'
                        },
                        disableClose: true
                      });
                      dialogRef.afterClosed().subscribe(result => {
                        if (result) {
                          this.manageService.GetMSCloudAgreementStatus(this.tenantId).subscribe((resp: SubscriptionApiResponse) => {
                            this.isSubscriptionResponseLoading = false;
                            this.subscriptionResponse = resp;
                          },
                            (error: any) => {
                              console.error(error);
                            });
                        }
                      });
                    } else if (this.subscriptionResponse.status === 'Fail') {
                      this.isSubscriptionResponseLoading = false;
                      this.cs.implementToast('Error in Microsoft Agreement API', 'Error');
                    } else {
                      // mca signed already
                      this.isMCASigned = true;
                      this.isSubscriptionResponseLoading = false;
                    }
                  },
                    (error: any) => {
                      console.error(error);
                      this.isSubscriptionResponseLoading = false;
                    });
              }
            }
          }
        });
    });
    this.manageService.getOrRefreshSubscriptionOrderSubject.next(false);

    // update pending software after confirm
    this.manageService.currentSoftwareConfirmValue.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
      if (value === 'Update') {
        this.loadCSPSoftware = false;
        this.cspSoftwareItems = [];
        this.manageService.GetCSPCustomerEntitlmentsView(this.tenantId)
          .subscribe((data: CSPCustomerEntitlementsViewModel[]) => {
            // data.forEach(element => {
            //   if (element.entitlementType === 'software') {
            //     this.cspSoftwareItems.push(element);
            //   }
            // });
            this.cspSoftwareItems = data.filter(element => element.entitlementType === 'software');
            this.loadCSPSoftware = true;
          },
            (error: any) => {
              console.error(error);
              this.loadCSPSoftware = true;
            });
      }
    });

    // update pending azureRi after confirm
    this.manageService.currentAzureRIConfirmValue.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
      if (value === 'Update') {
        this.loadCSPAzureri = false;
        this.cspReservedInstanceItems = [];
        this.manageService.GetCSPCustomerEntitlmentsView(this.tenantId)
          .subscribe((data: CSPCustomerEntitlementsViewModel[]) => {
            this.cspReservedInstanceItems = data.filter(element => element.entitlementType === 'reservedinstance');
            this.manageService.cspReservedInstanceItemsCount$.next(this.cspReservedInstanceItems.length);
            this.loadCSPAzureri = true;
          },
            (error: any) => {
              console.error(error);
              this.loadCSPAzureri = true;
            });
      }
    });

    this.manageService.currentSubscriptionConfirmValue.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
      if (value === 'Update') {
        this.manageService.GetCSPItemsView(this.tenantId).subscribe((model: CSPDetailsItemViewModel) => {
          this.activeTotal = '0';
          this.cSPDetailsItemViewModel = model;
          this.mpnList = model.mpnList;
          this.subscriptionActions = model.actions;
          this.nceRenewalPendingList = model.nceRenewalPendingList;
          this.manageService.setCurrentNCERenewalPendingList(this.nceRenewalPendingList)
          this.hasSubPending = false;
          this.subscriptions = this.cSPDetailsItemViewModel.subscriptions;
          this.groupingSubscriptions();
          // tslint:disable-next-line:no-shadowed-variable
          let addonTemIndex = -1;
          this.hasLegacy = false;
          this.subscriptions.forEach((subscription, baseIndex) => {

            if (!this.hasLegacy && subscription?.baseSubscription?.out_charge_type == 'SEAT') {
              this.hasLegacy = true;
            }

            subscription.baseSubscription.out_pendingMessage = '';
            let originalBaseQtyPair = {} as KeyValuePair;
            originalBaseQtyPair.id = subscription.baseSubscription.out_subscription_id;
            originalBaseQtyPair.value = subscription.baseSubscription.out_qty;
            this.originalBaseQty.push(originalBaseQtyPair);
            subscription.baseSubscription.out_price_number = this.cs.toNumber(subscription.baseSubscription.out_price);

            let originalBaseActive = {} as KeyValuePair;
            originalBaseActive.id = subscription.baseSubscription.out_subscription_id;
            originalBaseActive.value = subscription.baseSubscription.out_status_desc == 'Active';
            this.originalBaseActive.push(originalBaseActive);

            if (subscription.baseSubscription.out_status_desc === 'Active' && subscription.baseSubscription.out_stock_group !== '85CU') {
              subscription.baseSubscription.out_activeSuspend = true;
              // this.originalBaseActive.push(subscription.baseSubscription.out_activeSuspend);
              $(`#${subscription.baseSubscription.out_subscription_id} input[type="checkbox"]`).prop('checked', true);
              this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(subscription.baseSubscription.out_amount)).toString();
            } else {
              this.calculateTotalForNCE(subscription.baseSubscription);
              subscription.baseSubscription.out_activeSuspend = false;
              //this.originalBaseActive.push(subscription.baseSubscription.out_activeSuspend);
              $(`#${subscription.baseSubscription.out_subscription_id} input[type="checkbox"]`).prop('checked', false);
            }

            let originalAddOnQtyItem = {} as AddOnKeyValuePair;
            originalAddOnQtyItem.id = subscription.baseSubscription.out_subscription_id;
            let originalAddOnQtyList = [];

            let originalAddOnActiveItem = {} as AddOnKeyValuePair;
            originalAddOnActiveItem.id = subscription.baseSubscription.out_subscription_id;
            let originalAddOnActiveList = [];


            subscription.addOnSubscription.forEach((addOn) => {

              if (!this.hasLegacy && addOn?.out_charge_type == 'SEAT') {
                this.hasLegacy = true;
              }

              addOn.out_pendingMessage = '';

              let originalAddOnQty = {} as KeyValuePair;
              originalAddOnQty.id = addOn.out_subscription_id;
              originalAddOnQty.value = addOn.out_qty;
              originalAddOnQtyList.push(originalAddOnQty);


              addOn.out_price_number = this.cs.toNumber(addOn.out_price);

              let originalAddOnActive = {} as KeyValuePair;
              originalAddOnActive.id = addOn.out_subscription_id;
              originalAddOnActive.value = addOn.out_status_desc == 'Active' && subscription.baseSubscription.out_status_desc == 'Active';
              originalAddOnActiveList.push(originalAddOnActive);

              if (addOn.out_status_desc === 'Active' && addOn.out_stock_group !== '85CU') {
                addOn.out_activeSuspend = true;
                //const addonActiveSuspendTemp = { baseIndex: baseIndex, activeSuspend: addOn.out_activeSuspend };
                //this.originalAddonActive.push(addonActiveSuspendTemp);
                $(`#${addOn.out_subscription_id} input[type="checkbox"]`).prop('checked', true);
                this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(addOn.out_amount)).toString();
              } else {
                this.calculateTotalForNCE(addOn);
                addOn.out_activeSuspend = false;
                const addonActiveSuspendTemp = { baseIndex: baseIndex, activeSuspend: addOn.out_activeSuspend };
                //this.originalAddonActive.push(addonActiveSuspendTemp);
                $(`#${addOn.out_subscription_id} input[type="checkbox"]`).prop('checked', false);
              }
            });

            originalAddOnQtyItem.value = originalAddOnQtyList;
            this.originalAddonQty.push(originalAddOnQtyItem);

            originalAddOnActiveItem.value = originalAddOnActiveList;
            this.originalAddonActive.push(originalAddOnActiveItem);

            if (this.subscriptionActions.length) {
              this.subscriptionActions.forEach(subscriptionAction => {
                if (!subscriptionAction.out_error_message) {
                  if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id) {
                    subscription.baseSubscription.out_status = subscriptionAction.out_status;
                    subscription.baseSubscription.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                    subscription.baseSubscription.out_action_status = true;
                    if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY') {
                      subscription.baseSubscription.out_activeSuspend = false;
                      subscription.baseSubscription.out_status = 'XX';
                    } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY') {
                      subscription.baseSubscription.out_activeSuspend = true;
                      var orginalBaseActiveStatus = this.originalBaseActive.find(x => x.id == subscription.baseSubscription.out_subscription_id).value;
                      if (subscription.baseSubscription.out_activeSuspend === orginalBaseActiveStatus) {
                        subscription.baseSubscription.out_status = '';
                      } else {
                        subscription.baseSubscription.out_status = 'PR';
                      }
                    }
                  } else {
                    subscription.baseSubscription.out_action_status = false;
                  }
                  switch (subscriptionAction.out_key) {
                    case 'CREATE': { subscription.baseSubscription.out_pendingMessage = 'Pending Order Creation'; break; }
                    case 'QTY': { subscription.baseSubscription.out_pendingMessage = 'Pending Qty Change to ' + subscriptionAction.out_value; break; }
                    case 'MPNID': { subscription.baseSubscription.out_pendingMessage = 'Pending MPN ID Change to ' + subscriptionAction.out_value; break; }
                    case 'REF': { subscription.baseSubscription.out_pendingMessage = 'Pending Reference Change to ' + subscriptionAction.out_value; break; }
                    case 'SUSPEND':
                      {
                        subscription.baseSubscription.out_pendingMessage = 'Pending Suspension ';
                        break;
                      }
                    case 'REACTIVATE':
                      {
                        subscription.baseSubscription.out_pendingMessage = 'Pending Reactivation ';
                        break;
                      }
                  }
                }
              });
              subscription.addOnSubscription.forEach((addOn) => {
                addonTemIndex++;
                this.subscriptionActions.forEach(subscriptionAction => {
                  if (!subscriptionAction.out_error_message) {
                    if (subscription.baseSubscription.out_status !== 'XX' && subscriptionAction.out_subscription_id !== subscription.baseSubscription.out_subscription_id) {
                      if (subscriptionAction.out_subscription_id === addOn.out_subscription_id) {
                        addOn.out_status = subscriptionAction.out_status;
                        addOn.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                        addOn.out_action_status = true;
                        if (subscription.baseSubscription.out_activeSuspend) {
                          if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY') {
                            addOn.out_activeSuspend = false;
                            addOn.out_status = 'XX';
                          } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY') {
                            addOn.out_activeSuspend = true;


                            let originalAddOnActiveSuspendBase = this.originalAddonActive.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                            let originalAddOnActiveSuspend = originalAddOnActiveSuspendBase.value.find(x => x.id == addOn.out_subscription_id).value;

                            if (addOn.out_activeSuspend === originalAddOnActiveSuspend) {
                              addOn.out_status = '';
                            } else {
                              addOn.out_status = 'PR';
                            }
                          }
                        } else {
                          addOn.out_activeSuspend = false;
                          addOn.out_status = 'XX';
                        }
                      } else {
                        addOn.out_action_status = false;
                      }
                    } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscriptionAction.out_value === 'XX') {
                      addOn.out_status_desc = 'Pending Base Suspended';
                      addOn.out_activeSuspend = false;
                      $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                    } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscriptionAction.out_value !== 'XX') {
                      addOn.out_status_desc = 'Base Suspended';
                      addOn.out_activeSuspend = false;
                      $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                    } else {
                      addOn.out_status = 'XX';
                      addOn.out_activeSuspend = false;
                      addOn.out_status_desc = 'Base Pending Suspended';
                      $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                    }
                    switch (subscriptionAction.out_key) {
                      case 'CREATE': { addOn.out_pendingMessage = 'Pending Order Creation'; break; }
                      case 'QTY': { addOn.out_pendingMessage = 'Pending Qty Change to ' + subscriptionAction.out_value; break; }
                      case 'MPNID': { addOn.out_pendingMessage = 'Pending MPN ID Change to ' + subscriptionAction.out_value; break; }
                      case 'REF': { addOn.out_pendingMessage = 'Pending Reference Change to ' + subscriptionAction.out_value; break; }
                      case 'SUSPEND':
                        {
                          addOn.out_pendingMessage = 'Pending Suspension ';
                          break;
                        }
                      case 'REACTIVATE':
                        {
                          addOn.out_pendingMessage = 'Pending Reactivation ';
                          break;
                        }
                    }
                  }
                });
              });
            } else {
              subscription.baseSubscription.out_action_status = false;
              subscription.addOnSubscription.forEach(addOn => {
                addOn.out_action_status = false;
                if (subscription.baseSubscription.out_status === 'XX') {
                  addOn.out_status_desc = 'Base Suspended';
                  addOn.out_activeSuspend = false;
                  $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                }
              });
            }
          });
          this.manageService.monitorExistingCSPSubscrptions([...this.subscriptions]);

          this.cs.applyScrollFixedHeader(this.parentWrapper);
        },
          (error: any) => {
            console.error(error);
          });
      }
    });

    this.getPendingAddOn();
    // this.getPendingSubscription();

    this.manageService.refetchCSPItemsView$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.refetchCSPItemsView();
    });
    this.getCSPItemsView(true);
    this.manageService.refetchSoftwareSubscription$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.refreshSoftwareSubscription();
    });

    this.manageService._softwareTabClick$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(open => {
      if (open && !this.softwareTabOpened) {
        this.loadCSPSoftwareSubscriptionsView();
        this.softwareTabOpened = true;
        this.panelSoftwareOpen = true;
      }
    });
  }

  getCSPItemsView(openTab: boolean): void {
    this.isCSPItemLoading = true;
    this.panelNCESubscriptionOpen = openTab;
    // subscriptions details
    this.manageService.GetCSPItemsView(this.tenantId).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: CSPDetailsItemViewModel) => {
        this.cSPDetailsItemViewModel = res;
        this.purchase = res.purchase;
        this.mpnList = res.mpnList;
        this.subscriptionActions = res.actions;
        this.nceRenewalPendingList = res.nceRenewalPendingList;
        this.manageService.setCurrentNCERenewalPendingList(this.nceRenewalPendingList)
        this.activeTotal = '0';
        this.subscriptions = this.cSPDetailsItemViewModel.subscriptions;
        this.groupingSubscriptions();
        let addonTemIndex = -1;

        this.manageService.monitorCSPPurchase(this.purchase);
        this.manageService.monitorMPNList(this.mpnList);

        this.hasLegacy = false;

        this.subscriptions.forEach((subscription) => {

          if (!this.hasLegacy && subscription?.baseSubscription?.out_charge_type == 'SEAT') {
            this.hasLegacy = true;
          }

          subscription.baseSubscription.cancelingNceSub = subscription.baseSubscription.out_status_desc == this.cancelDescText;
          subscription.baseSubscription.editMpnIdValue = subscription.baseSubscription.out_mpnid;
          subscription.baseSubscription.editMpnBool = false;
          subscription.baseSubscription.editDescValue = subscription.baseSubscription.out_sub_description;
          subscription.baseSubscription.editDescBool = false;
          subscription.baseSubscription.originalMpnId = subscription.baseSubscription.out_mpnid;
          subscription.baseSubscription.originalDesc = subscription.baseSubscription.out_sub_description;
          subscription.baseSubscription.out_pendingMessage = '';
          let originalBaseQtyPair = {} as KeyValuePair;
          originalBaseQtyPair.id = subscription.baseSubscription.out_subscription_id;
          originalBaseQtyPair.value = subscription.baseSubscription.out_qty;
          this.originalBaseQty.push(originalBaseQtyPair);
          subscription.baseSubscription.out_price_number = this.cs.toNumber(subscription.baseSubscription.out_price);
          let originalBaseActive = {} as KeyValuePair;
          originalBaseActive.id = subscription.baseSubscription.out_subscription_id;
          originalBaseActive.value = subscription.baseSubscription.out_status_desc == 'Active';
          this.originalBaseActive.push(originalBaseActive);

          // if (subscription.baseSubscription.out_status_desc === 'Active' && subscription.baseSubscription.out_stock_group !== '85CU') {
          if (subscription.baseSubscription.out_status_desc === 'Active') {
            subscription.baseSubscription.out_activeSuspend = true;
            //this.originalBaseActive.push(subscription.baseSubscription.out_activeSuspend);
            this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(subscription.baseSubscription.out_amount)).toString();
          } else {
            this.calculateTotalForNCE(subscription.baseSubscription);
            subscription.baseSubscription.out_activeSuspend = false;
            //this.originalBaseActive.push(subscription.baseSubscription.out_activeSuspend);
          }

          let originalAddOnQtyItem = {} as AddOnKeyValuePair;
          originalAddOnQtyItem.id = subscription.baseSubscription.out_subscription_id;
          let originalAddOnQtyList = [];

          let originalAddOnActiveItem = {} as AddOnKeyValuePair;
          originalAddOnActiveItem.id = subscription.baseSubscription.out_subscription_id;
          let originalAddOnActiveList = [];

          let originalAddOnMPNIdItem = {} as AddOnKeyValuePair;
          originalAddOnMPNIdItem.id = subscription.baseSubscription.out_subscription_id;
          let originalAddOnMPNIdList = [];

          subscription.addOnSubscription.forEach((addOn) => {
            if (!this.hasLegacy && addOn?.out_charge_type == 'SEAT') {
              this.hasLegacy = true;
            }
            addOn.out_pendingMessage = '';
            addOn.cancelingNceSub = addOn.out_status_desc == this.cancelDescText;
            addOn.editMpnIdValue = addOn.out_mpnid;
            addOn.editMpnBool = false;
            addOn.editDescValue = addOn.out_sub_description;
            addOn.editDescBool = false;
            addOn.originalMpnId = addOn.out_mpnid;
            addOn.originalDesc = addOn.out_sub_description;


            let originalAddOnQty = {} as KeyValuePair;
            originalAddOnQty.id = addOn.out_subscription_id;
            originalAddOnQty.value = addOn.out_qty;
            originalAddOnQtyList.push(originalAddOnQty);

            //this.originalAddonQty.push(addonQtyTemp);

            addOn.out_price_number = this.cs.toNumber(addOn.out_price);

            let originalAddOnActive = {} as KeyValuePair;
            originalAddOnActive.id = addOn.out_subscription_id;
            originalAddOnActive.value = addOn.out_status_desc == 'Active' && subscription.baseSubscription.out_status_desc == 'Active';
            originalAddOnActiveList.push(originalAddOnActive);

            let originalAddOnMPNId = {} as KeyValuePair;
            originalAddOnMPNId.id = addOn.out_subscription_id;
            originalAddOnMPNId.value = addOn.originalMpnId;
            originalAddOnMPNIdList.push(originalAddOnMPNId)

            if (addOn.out_status_desc === 'Active' && subscription.baseSubscription.out_status_desc === 'Active' && subscription.baseSubscription.out_stock_group !== '85CU') {
              addOn.out_activeSuspend = true;
              // const addonActiveSuspendTemp = { baseIndex: baseIndex, activeSuspend: addOn.out_activeSuspend };
              // this.originalAddonActive.push(addonActiveSuspendTemp);
              this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(addOn.out_amount)).toString();
            } else {
              this.calculateTotalForNCE(addOn);
              addOn.out_activeSuspend = false;
              // const addonActiveSuspendTemp = { baseIndex: baseIndex, activeSuspend: addOn.out_activeSuspend };
              // this.originalAddonActive.push(addonActiveSuspendTemp);
            }
          });

          originalAddOnQtyItem.value = originalAddOnQtyList;
          this.originalAddonQty.push(originalAddOnQtyItem);

          originalAddOnActiveItem.value = originalAddOnActiveList;
          this.originalAddonActive.push(originalAddOnActiveItem);

          originalAddOnMPNIdItem.value = originalAddOnMPNIdList;
          this.originalAddonMPNId.push(originalAddOnMPNIdItem);

          if (this.subscriptionActions.length) {
            this.subscriptionActions.forEach(subscriptionAction => {
              if (!subscriptionAction.out_error_message) {
                if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id) {
                  subscription.baseSubscription.out_status = subscriptionAction.out_status;
                  subscription.baseSubscription.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                  subscription.baseSubscription.out_action_status = true;
                  if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY' && subscriptionAction.out_key !== 'REF') {
                    subscription.baseSubscription.out_activeSuspend = false;
                    subscription.baseSubscription.out_status = 'XX';
                  } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY' && subscriptionAction.out_key !== 'REF') {
                    subscription.baseSubscription.out_activeSuspend = true;

                    var orginalBaseActiveStatus = this.originalBaseActive.find(x => x.id == subscription.baseSubscription.out_subscription_id).value;
                    if (subscription.baseSubscription.out_activeSuspend === orginalBaseActiveStatus) {
                      subscription.baseSubscription.out_status = '';
                    } else {
                      subscription.baseSubscription.out_status = 'PR';
                    }
                  }
                } else {
                  subscription.baseSubscription.out_action_status = false;
                }
              }
            });
            subscription.addOnSubscription.forEach((addOn) => {
              addonTemIndex++;
              this.subscriptionActions.forEach(subscriptionAction => {
                if (!addOn.out_error_message) {
                  if (subscription.baseSubscription.out_status !== 'XX' && subscriptionAction.out_subscription_id !== subscription.baseSubscription.out_subscription_id) {
                    if (subscriptionAction.out_subscription_id === addOn.out_subscription_id) {
                      addOn.out_status = subscriptionAction.out_status;
                      addOn.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                      addOn.out_action_status = true;
                      if (subscription.baseSubscription.out_activeSuspend) {
                        if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY' && subscriptionAction.out_key !== 'REF') {
                          addOn.out_activeSuspend = false;
                          addOn.out_status = 'XX';
                        } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY' && subscriptionAction.out_key !== 'REF') {
                          addOn.out_activeSuspend = true;


                          let originalAddOnActiveItem = this.originalAddonActive.find(x => x.id == subscription.baseSubscription.out_subscription_id).value;
                          let originalAddOnActiveSuspend = originalAddOnActiveItem.find(x => x.id == addOn.out_subscription_id).value;
                          if (addOn.out_activeSuspend === originalAddOnActiveSuspend) {
                            addOn.out_status = '';
                          } else {
                            addOn.out_status = 'PR';
                          }
                        }
                      } else {
                        addOn.out_activeSuspend = false;
                        addOn.out_status = 'XX';
                      }
                    } else {
                      addOn.out_action_status = false;
                    }
                  } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscription.baseSubscription.out_status === 'XX') {
                    addOn.out_status_desc = 'Pending Base Suspended';
                    addOn.out_activeSuspend = false;
                    $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                  } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscription.baseSubscription.out_status !== 'XX') {
                    /**
                     * Issue:
                     * If they change a base sub qty, then all of it's add-on subs statuses getting changed to "Base Suspended"
                     */
                    // addOn.out_status_desc = 'Base Suspended';
                    // $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                  } else {
                    addOn.out_activeSuspend = false;
                    addOn.out_status = 'XX';
                    addOn.out_status_desc = 'Base Suspended';
                    $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                  }
                }
              });
            });
          } else {
            subscription.baseSubscription.out_action_status = false;
            subscription.addOnSubscription.forEach(addOn => {
              addOn.out_action_status = false;
              if (subscription.baseSubscription.out_status === 'XX') {
                addOn.out_status_desc = 'Base Suspended';
                addOn.out_activeSuspend = false;
                $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
              }
            });
          }
        });
        this.manageService.monitorExistingCSPSubscrptions([...this.subscriptions]);

        this.manageService.GetAzureSubscriptionTotals(this.tenantId).subscribe((cspUsage: any) => {
          // to update subscription usage line total for azure on subscription details page
          this.subscriptions.forEach((subscription) => {
            subscription.baseSubscription.priceLoadingStatus = false;
            subscription.baseSubscription.loadingStatus = false;
            if (subscription.baseSubscription.out_stock_group === '85CU') {
              const subscriptionUsageDetails = cspUsage.filter(x => x.subscriptionId === subscription.baseSubscription.out_subscription_id);
              if (subscriptionUsageDetails != null && subscriptionUsageDetails.length > 0) {
                subscription.baseSubscription.out_amount = subscriptionUsageDetails[0].total.toString();
                subscription.baseSubscription.priceLoadingStatus = true;
              } else {
                subscription.baseSubscription.out_amount = '0';
                subscription.baseSubscription.priceLoadingStatus = true;
              }
              this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(subscription.baseSubscription.out_amount)).toString();
            }
          });
          this.totalPriceChange = this.calculateTotalPriceChange();
          this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
          this.subscriptions.forEach(value => {
            if (value.baseSubscription.out_stock_code.includes('MS-AZR-0145') && value.baseSubscription.out_status === 'XX') {
              this.hasPendingAzureProduct = true;
            }
            if (value.baseSubscription.out_stock_code.includes('DZH318Z0BPS6:0001')) {
              this.hasPendingAzureProduct = false;
            }
          });
          this.subscriptions.forEach(value => {
            this.showAzurePlan = false;
            this.isAzureUpgradeInProgress = false;
            if (value.baseSubscription.out_stock_code.includes('MS-AZR-0145') && value.baseSubscription.out_status_desc === 'Active' && !this.hasPendingAzureProduct) {
              this.authService.getLoginInfo().subscribe((model: CurrentUserModel) => {
                if (model.isStaffAccount || model.isImpersonated) {
                  this.manageService.IsAzureUpgradeInProgress(this.tenantId).subscribe(azureUpgrade => {
                    if (azureUpgrade.status === true) {
                      this.isAzureUpgradeInProgress = true;
                      this.showAzurePlan = false;
                      return;
                    } else if (azureUpgrade.status === false) {
                      this.isAzureUpgradeInProgress = false;
                      this.showAzurePlan = true;
                      return;
                    }
                  });
                }
              },
                (error: any) => {
                  console.error(error);
                });
            }
          });
        },
          (error: any) => {
            console.error(error);
          });
        this.isCSPItemLoading = false;
        this.panelNCESubscriptionOpen = openTab;
        this.cs.applyScrollFixedHeader(this.parentWrapper);
      },
        (error: any) => {
          console.error(error);
        });
  }

  calculateTotalForNCE(sub: GetCSPSubscription) {
    if (sub.out_status_desc == 'Suspended' && sub.out_charge_type == 'NCE' && sub.out_stock_group !== '85CU') {
      this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(sub.out_amount)).toString();
    }
  }

  trackByFn(index, item) {
    return index;
  }

  getPendingAddOn(): void {
    this.manageService.currentPendingAddon.pipe(skip(1)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((model: AnnuityItemsViewModel[]) => {
      if (model && model.length > 0) {
        let defaultMpn: string;
        let cspSubscription: CSPSubscriptions;
        cspSubscription = this.subscriptions.find((sub) => sub.baseSubscription.out_parent_subscription === model[0].annuityId)
        defaultMpn = cspSubscription.baseSubscription.out_mpnid;

        // generate formcontrol for each pending addon
        model.forEach((result, index) => {
          result.totalPrice = this.cs.toNumber(result.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(result.quantity);
          if (this.totalPriceChange) {
            this.totalPriceChange += result.totalPrice;
          } else {
            this.totalPriceChange += (result.totalPrice + this.cs.toNumber(this.activeTotal));
          }
          this.pendingTotal = Math.abs(this.cs.round(this.cs.toNumber(this.activeTotal), 2) - this.cs.round(this.totalPriceChange, 2));
          result.mpn = defaultMpn;
          if (result.mpn) {
            result.editMPN = false;
          }
          if (!cspSubscription.pendingAddOnSubscription) cspSubscription.pendingAddOnSubscription = []
          cspSubscription.pendingAddOnSubscription.push(result);
          this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('', null, 0, 0);
        });
        this.groupingSubscriptions();
      }
    },
      (error: any) => {
        console.error(error);
      });
  }

  getPendingSubscription(): void {
    this.manageService.currentPendingSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe((model: AnnuityItemsViewModel[]) => {
      if (model && model.length > 0) {
        this.annuityItemsPendingList = [];
        // this.manageService.currentMPNIDCheckPendingValue.subscribe(status => this.checkMpnId = status);
        model.forEach(result => {
          if (result && !result.isExisting) {
            result.totalPrice = this.cs.toNumber(result.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(result.quantity);
            result.ownerEmailStatus = false;
            this.annuityItemsPendingList.push(result);
            this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('', null, 0, 0);
            this.pendingRowConfirmStatus = true;
          } else if (result && result.isExisting) {
            this.subscriptions.forEach((subscription, index) => {
              if (subscription.baseSubscription.out_stock_code === result.stockCode) {
                subscription.baseSubscription.out_qty = (this.cs.toNumber(subscription.baseSubscription.out_qty) + this.cs.toNumber(result.quantity)).toString();
                this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, 0);
              }
              subscription.addOnSubscription.forEach((addon, addonIndex) => {
                if (addon.out_stock_code === result.stockCode) {
                  addon.out_qty = (this.cs.toNumber(addon.out_qty) + this.cs.toNumber(result.quantity)).toString();
                  this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', addon, index, addonIndex);
                }
              });
            });
          }
        });
        this.totalPriceChange = this.calculateTotalPriceChange();
        this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
        if (!this.pendingTotal) {
          this.totalPriceChange = 0;
        }
      } else {
        this.totalPriceChange = this.calculateTotalPriceChange();
        this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
        if (!this.pendingTotal) {
          this.totalPriceChange = 0;
        }
      }
    },
      (error: any) => {
        console.error(error);
      });
  }

  headerLinkClick(event): void {
    event.stopPropagation();
    event.preventDefault();
    window.open(this.headerLink.link, '_blank');
  }

  reportClick(): void {
    event.stopPropagation();
    event.preventDefault();
    this.router.navigateByUrl('/reporting');
  }

  isNotValidField(path: string, validation: any): void {
    if (this.agreement.get(path).hasError('required')) {
      this.cs.showValidator('#' + validation[0].class, validation[0].message, 'right', 'error');
    }
  }

  toggleBaseActive(event: any, subscription: CSPSubscriptions, index: number): void {
    if (!event.checked) {
      subscription.baseSubscription.out_activeSuspend = false;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, 0);
      if (this.pendingRowConfirmStatus) {
        //subscription.baseSubscription.out_qty = this.originalBaseQty[index];
        subscription.baseSubscription.out_qty = this.originalBaseQty.find(e => e.id == subscription.baseSubscription.out_subscription_id).value;
        $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;

          let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
          let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;

          addon.out_qty = originalAddOnQty;
          //addon.out_qty = this.originalAddonQty.filter(x => x.baseIndex === index)[idx].qty;
          $(`#${addon.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
        });
      } else {
        $(`#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`).remove();
        $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;
          let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
          let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;
          addon.out_qty = originalAddOnQty;

          //addon.out_qty = this.originalAddonQty.filter(x => x.baseIndex === index)[idx].qty;
          $(`#${addon.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
        });
      }
    } else {
      subscription.baseSubscription.out_activeSuspend = true;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, 0);
      if (this.pendingRowConfirmStatus) {
        //subscription.baseSubscription.out_qty = this.originalBaseQty[index];
        subscription.baseSubscription.out_qty = this.originalBaseQty.find(e => e.id == subscription.baseSubscription.out_subscription_id).value;
        $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;


          let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
          let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;
          addon.out_qty = originalAddOnQty;

          //addon.out_qty = this.originalAddonQty.filter(x => x.baseIndex === index)[idx].qty;
          $(`#${addon.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
        });
      } else {
        $(`#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`).remove();
        $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
        subscription.addOnSubscription.map((addon, idx) => {

          let originalAddOnActiveSuspendBase = this.originalAddonActive.find(x => x.id == subscription.baseSubscription.out_subscription_id);
          let originalAddOnActiveSuspend = originalAddOnActiveSuspendBase.value.find(x => x.id == addon.out_subscription_id).value;
          addon.out_activeSuspend = originalAddOnActiveSuspend;

          let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
          let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;
          addon.out_qty = originalAddOnQty;
          //addon.out_activeSuspend = this.originalAddonActive.filter(x => x.baseIndex === index)[idx].activeSuspend;
          // addon.out_qty = this.originalAddonQty.filter(x => x.baseIndex === index)[idx].qty;
          $(`#${addon.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
        });
      }
    }
    this.totalPriceChange = this.calculateTotalPriceChange();
    this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
    if (!this.pendingTotal) {
      this.totalPriceChange = 0;
    }
    //this.hasZeroQtySub = this.checkZeroQty();
  }

  toggleActive(event: any, item: CSPPerpetualItemsViewModel): void {

    item.isMonthly = event.checked;

    if (item.isMonthly) {
      item.totalPrice = this.cs.toNumber(item.monthlyPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(item.quantity);
    } else {
      item.totalPrice = this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(item.quantity);
    }

    //this.hasZeroQtySub = this.checkZeroQty();
  }

  toggleAddonActive(event: any, subscription: GetCSPSubscription, index: number, addonIdx: number): void {
    if (!event.checked) {
      subscription.out_activeSuspend = false;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, index, addonIdx);
      if (this.pendingRowConfirmStatus) {

        let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.out_parent_subscription);
        let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == subscription.out_subscription_id).value;


        // subscription.out_qty = this.originalAddonQty.filter(x => x.baseIndex === index)[addonIdx].qty;
        subscription.out_qty = originalAddOnQty;
        $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
      } else {
        $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
        $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
      }
    } else {
      subscription.out_activeSuspend = true;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, index, addonIdx);
      if (this.pendingRowConfirmStatus) {

        let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.out_parent_subscription);
        let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == subscription.out_subscription_id).value;
        subscription.out_qty = originalAddOnQty;

        // subscription.out_qty = this.originalAddonQty.filter(x => x.baseIndex === index)[addonIdx].qty;
        $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
      } else {
        $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
        $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
      }
    }
    this.totalPriceChange = this.calculateTotalPriceChange();
    this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
    if (!this.pendingTotal) {
      this.totalPriceChange = 0;
    }

    //this.hasZeroQtySub = this.checkZeroQty();
  }

  updateQty(type: string, subscription: GetCSPSubscription, index: number, addonIndex: number): void {

    if (this.cs.toNumber(subscription.out_qty) > 0) {
      if (this.cs.toInteger(subscription.out_min_order_qty) !== 0 && this.cs.toNumber(subscription.out_min_order_qty) > this.cs.toNumber(subscription.out_qty)) {
        this.invalidQtyInput = true;
        // subscription.out_qty = this.cs.toInteger(subscription.out_min_order_qty.replace(',', '')).toString();
        if (subscription.out_qty !== subscription.out_confirmed_qty) {
          this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(type, subscription, index, addonIndex);
        }
        // this.cs.showValidator(`#${subscription.out_subscription_id} .qty`, "Minimum qty for this item is " + this.cs.toInteger(subscription.out_min_order_qty.replace(',', '')).toString(), "right", "error");
        this.cs.implementToast('Minimum qty for this item is ' + this.cs.toInteger(subscription.out_min_order_qty.replace(',', '')).toString(), 'Error');
      } else if (this.cs.toInteger(subscription.out_max_order_qty) !== 0 && this.cs.toNumber(subscription.out_qty) > this.cs.toNumber(subscription.out_max_order_qty)) {
        // this.cs.showValidator(`#${subscription.out_subscription_id} .qty`, "Maximum qty for this item is " + this.cs.toInteger(subscription.out_max_order_qty.replace(',', '')).toString(), "right", "error");
        this.cs.implementToast('Maximum qty for this item is ' + this.cs.toInteger(subscription.out_max_order_qty.replace(',', '')).toString(), 'Error');
        this.invalidQtyInput = true;
        // subscription.out_qty = this.cs.toInteger(subscription.out_max_order_qty.replace(',', '')).toString();
        if (subscription.out_qty !== subscription.out_confirmed_qty) {
          this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(type, subscription, index, addonIndex);
        }
      } else {
        //this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(type, subscription, index, addonIndex);
        subscription.pendingRowConfirmStatus = this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(type, subscription, index, addonIndex);
        this.invalidQtyInput = false;
      }
    } else {
      // this.cs.showValidator(`#${subscription.out_subscription_id} .qty`, "Qty must be greater than 0", "right", "error");
      this.cs.implementToast('Qty must be greater than 0', 'Error');
      //subscription.out_qty = '1';
    }

    this.hasZeroQtySub = this.checkZeroQty();
    this.totalPriceChange = this.calculateTotalPriceChange();
    this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
    if (!this.pendingTotal) {
      this.totalPriceChange = 0;
    }
  }
  //zero qty check

  checkZeroQty(): boolean {
    let hasZeroQty = false;

    for (let i = 0; i < this.subscriptions.length; i++) {
      if (this.subscriptions[i].baseSubscription.out_activeSuspend && this.subscriptions[i].baseSubscription.out_qty == '0' || this.subscriptions[i].addOnSubscription.some((addon) => { return addon.out_activeSuspend && addon.out_qty == '0' })) {
        hasZeroQty = true;
        break;
      }
    }
    return hasZeroQty;
  }

  onPendingMPNIdChang(addonItemPending: AnnuityItemsViewModel): void {
    if (!addonItemPending.mpn) {
      this.cs.implementToast('MPN is mandatory', 'Error');
    } else {
      addonItemPending.editMPN = false;
    }
  }

  confirmSubscription(): void {

    this.hasNCESub = false;

    let addonListPendingList: AnnuityItemsViewModel[] = [];

    [...this.licenseSubs, ...this.nceSubs].forEach((subscription) => {
      if (subscription.pendingAddOnSubscription && subscription.pendingAddOnSubscription.length > 0) {
        subscription.pendingAddOnSubscription.forEach((pendingAddon) => {
          addonListPendingList.push(pendingAddon);
        })
      }
    })

    // check mpnId is not empty for all pendingSubscritions
    for (let i = 0; i < addonListPendingList.length; i++) {
      if (!addonListPendingList[i].mpn) {
        this.cs.implementToast('MPN is mandatory', 'Error');
        return;
      }
    }

    let flag = false;

    if (this.annuityItemsPendingList.length) {
      this.annuityItemsPendingList.forEach(item => {
        // if (!item.mpn) {
        //   this.cs.implementToast('Please choose or input MPN ID', 'Error');
        //   flag = true;
        // }

        if (item.stockGroup === '85CU') {
          if (!item.ownerEmailStatus) {
            this.cs.implementToast('Please provide valid existing user email or external domain user email', 'Error');
            flag = true;
          }
        }
      });
    }

    if (addonListPendingList.length) {
      addonListPendingList.forEach(item => {
        if (!item.mpn) {
          // this.cs.showError("#" + item.stockCode, "Please choose or input MPN ID", "right");
          this.cs.implementToast('Please choose or input MPN ID', 'Error');
          flag = true;
        }
      });
    }

    if (!flag) {
      this.changeSubscriptionAmount = 0;
      this.confirmSubscriptions = [];
      let addonTemIndex = -1;

      [...this.nceSubs, ...this.licenseSubs].map((subscription, baseIndex) => {
        let originalBaseQtyItem = this.originalBaseQty.find(e => e.id == subscription.baseSubscription.out_subscription_id).value;
        let originalBaseActiveItem = this.originalBaseActive.find(e => e.id == subscription.baseSubscription.out_subscription_id).value;
        if (subscription.baseSubscription.out_qty !== originalBaseQtyItem || subscription.baseSubscription.out_activeSuspend !== originalBaseActiveItem || subscription.baseSubscription.out_sub_description !== subscription.baseSubscription.originalDesc || subscription.baseSubscription.editMpnIdValue !== subscription.baseSubscription.originalMpnId) {
          this.changeSubscriptionAmount++;
          this.confirmBaseSubscription = {} as CSPModifySubscriptionViewModel;
          this.confirmBaseSubscription = {
            tenantId: subscription.baseSubscription.out_tenant_id,
            mpnId: this.cs.parseNPM(subscription.baseSubscription.editMpnIdValue),
            subscriptionId: subscription.baseSubscription.out_subscription_id,
            subscriptionDescription: subscription.baseSubscription.out_sub_description,
            customerReference: this.poReference,
            stockDescription: subscription.baseSubscription.out_stk_description,
            parentSubscriptionId: subscription.baseSubscription.out_parent_subscription,
            stockCode: subscription.baseSubscription.out_stock_code,
            qty: subscription.baseSubscription.out_qty,
            status: subscription.baseSubscription.out_activeSuspend ? 'PR' : 'XX',
            ownerEmail: subscription.baseSubscription.out_default_email,
            price: subscription.baseSubscription.out_price,
            totalPrice: subscription.baseSubscription.out_amount,
            billingFrequency: subscription.baseSubscription.out_billing_freq,
            chargeType: subscription.baseSubscription.out_charge_type
          };
          if (subscription.baseSubscription.out_activeSuspend !== originalBaseActiveItem) {
            this.confirmBaseSubscription.status = subscription.baseSubscription.out_activeSuspend ? 'PR' : 'XX';
          } else {
            this.confirmBaseSubscription.status = originalBaseActiveItem ? '' : 'XX';
          }
          if (!this.hasNCESub) {
            if (subscription.baseSubscription.out_charge_type == 'NCE') {
              this.hasNCESub = true;
            }
          }
          this.confirmSubscriptions.push(this.confirmBaseSubscription);
        }

        subscription.addOnSubscription.map((addon) => {
          addonTemIndex++;
          // prepare orginal data for changes detection 
          let originalAddOnQtyItemBase = this.originalAddonQty.find(e => e.id == addon.out_parent_subscription).value;
          let originalAddOnQtyItem = originalAddOnQtyItemBase.find(e => e.id == addon.out_subscription_id).value;

          let originalAddOnActiveItemBase = this.originalAddonActive.find(e => e.id == addon.out_parent_subscription).value;
          let originalAddOnActiveItem = originalAddOnActiveItemBase.find(e => e.id == addon.out_subscription_id).value;

          let originalAddOnMPNIdBase = this.originalAddonMPNId.find(e => e.id == addon.out_parent_subscription).value;
          let originalAddOnMPNId = originalAddOnMPNIdBase.find(e => e.id == addon.out_subscription_id).value;

          // if we detect any changes below, we put into update list
          if (subscription.baseSubscription.out_activeSuspend &&
            (
              addon.out_qty !== originalAddOnQtyItem ||
              addon.out_activeSuspend !== originalAddOnActiveItem ||
              addon.out_sub_description !== addon.originalDesc ||
              addon.editMpnIdValue !== originalAddOnMPNId
            )
          ) {
            this.confirmAddonSubscription = {} as CSPModifySubscriptionViewModel;
            this.confirmAddonSubscription = {
              tenantId: addon.out_tenant_id,
              mpnId: this.cs.parseNPM(addon.out_mpnid == '' ? subscription.baseSubscription.out_mpnid : addon.out_mpnid),
              subscriptionId: addon.out_subscription_id,
              subscriptionDescription: addon.out_sub_description,
              customerReference: this.poReference,
              stockDescription: addon.out_stk_description,
              parentSubscriptionId: addon.out_parent_subscription,
              stockCode: addon.out_stock_code,
              qty: addon.out_qty,
              status: addon.out_activeSuspend ? 'PR' : 'XX',
              ownerEmail: addon.out_default_email,
              price: addon.out_price,
              totalPrice: addon.out_amount,
              billingFrequency: addon.out_billing_freq,
              chargeType: addon.out_charge_type
            };

            if (subscription.baseSubscription.out_activeSuspend !== originalBaseActiveItem) {
              this.confirmAddonSubscription.status = originalAddOnActiveItem ? '' : 'XX';
            } else {
              if (addon.out_activeSuspend !== originalAddOnActiveItem) {
                this.confirmAddonSubscription.status = addon.out_activeSuspend ? 'PR' : 'XX';
              } else {
                this.confirmAddonSubscription.status = originalAddOnActiveItem ? '' : 'XX';
              }
            }

            this.confirmSubscriptions.push(this.confirmAddonSubscription);
            if (subscription.baseSubscription.out_activeSuspend === originalBaseActiveItem) {
              this.changeSubscriptionAmount++;
            }
          }
        });
      });

      this.annuityItemsPendingList.forEach(annuityItem => {
        this.confirmAnnuityItemSubscription = {} as CSPModifySubscriptionViewModel;
        this.confirmAnnuityItemSubscription = {
          tenantId: this.tenantId,
          mpnId: this.cs.parseNPM(annuityItem.mpn),
          subscriptionId: '',
          subscriptionDescription: annuityItem.subscriptionDescription,
          customerReference: this.poReference,
          stockDescription: annuityItem.description,
          parentSubscriptionId: '',
          stockCode: annuityItem.stockCode,
          qty: annuityItem.quantity,
          status: '',
          ownerEmail: annuityItem.ownerEmail,
          price: annuityItem.itemPrice,
          totalPrice: annuityItem.totalPrice.toString(),
          billingFrequency: annuityItem.billingFrequency,
          stockGroup: annuityItem.stockGroup,
          chargeType: annuityItem.chargeType
        };
        if (this.confirmAnnuityItemSubscription.tenantId) {
          this.confirmSubscriptions.push(this.confirmAnnuityItemSubscription);
        }
      });

      addonListPendingList.forEach(annuityItem => {
        this.confirmAnnuityItemSubscription = {} as CSPModifySubscriptionViewModel;
        this.confirmAnnuityItemSubscription = {
          tenantId: this.tenantId,
          mpnId: this.cs.parseNPM(annuityItem.mpn),
          subscriptionId: '',
          subscriptionDescription: annuityItem.subscriptionDescription,
          customerReference: this.poReference,
          stockDescription: annuityItem.description,
          parentSubscriptionId: annuityItem.annuityId,
          stockCode: annuityItem.stockCode,
          qty: annuityItem.quantity,
          status: '',
          ownerEmail: '',
          price: annuityItem.itemPrice,
          totalPrice: annuityItem.totalPrice.toString(),
          billingFrequency: annuityItem.billingFrequency,
          chargeType: annuityItem.chargeType
        };
        if (this.confirmAnnuityItemSubscription.tenantId) {
          this.confirmSubscriptions.push(this.confirmAnnuityItemSubscription);
        }
      });

      if (this.confirmSubscriptions.length) {
        const tempMPNIdArray = [];
        let isValid = true;
        this.confirmSubscriptions.forEach(item => {
          // if (!item.mpnId || item.mpnId === '') {
          //   this.cs.implementToast('Please select MPN ID', 'Error');
          //   isValid = false;
          // }

          if (item.mpnId && item.mpnId !== '' && tempMPNIdArray.indexOf(item.mpnId) === -1) {
            tempMPNIdArray.push(item.mpnId); // get unique mpnId
          }
        });

        if (tempMPNIdArray.length && isValid) {
          this.validateMpnId(tempMPNIdArray, this.confirmSubscriptions);
        } else {
          this.openConfirmPendingModal();
          // this.cs.implementToast('Please select MPN ID', 'Error');
        }
      } else {
        this.cs.implementToast('There is no pending subscription to confirm', 'Error');
      }
    }
  }

  openConfirmPendingModal(): void {
    const dialogRef = this.dialog.open(ConfirmSubscriptionComponent, {
      width: '650px',
      panelClass: 'mat-dialog-wrapper',
      data: { totalPriceChange: this.totalPriceChange, pendingTotal: this.pendingTotal, hasNCE: this.hasNCESub }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.poReference = result;
        this.cs.createCookie('ChangeSubscriptionAmount', this.changeSubscriptionAmount.toString(), 1);
        this.changeSubscriptionAmount = this.cs.toNumber(this.cs.readCookie('ChangeSubscriptionAmount'));

        if (this.confirmSubscriptions.length) {

          this.confirmSubscriptions.map(item => {
            item.customerReference = this.poReference;
          });

          this.createOrUpdateCSPSubscriptions();

        }
      }
    });
  }

  createOrUpdateCSPSubscriptions(): void {
    this.manageService.createOrUpdateCSPSubscription(this.confirmSubscriptions).subscribe((res: CSPModifySubscriptionResponse[]) => {
      if (res.length) {
        this.finishSubscriptions = res;
        const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
          width: '650px',
          data: { finishSubscriptions: this.finishSubscriptions },
          panelClass: 'mat-dialog-wrapper',
          disableClose: true
        });

        dialogRefFinish.afterClosed().subscribe(() => {
          this.subscriptionActions = [];
          this.originalBaseQty = [];
          this.originalAddonQty = [];
          this.originalBaseActive = [];
          this.originalAddonActive = [];
          this.subscriptionActions = [];
          this.annuityItemsPendingList = [];
          //this.addonListPendingList = [];

          this.hasSubPending = false;
          this.totalPriceChange = 0;
          this.pendingRowConfirmStatus = false;
          this.pendingTotal = 0;
          this.changeSubscriptionAmount = this.cs.toNumber(this.cs.readCookie('ChangeSubscriptionAmount'));
          this.manageService.GetCSPItemsView(this.tenantId).subscribe((model: CSPDetailsItemViewModel) => {
            this.activeTotal = '0';
            this.cSPDetailsItemViewModel = model;
            this.mpnList = model.mpnList;
            this.subscriptionActions = model.actions;
            this.nceRenewalPendingList = model.nceRenewalPendingList;
            this.manageService.setCurrentNCERenewalPendingList(this.nceRenewalPendingList)
            this.subscriptions = this.cSPDetailsItemViewModel.subscriptions;
            this.groupingSubscriptions();
            // tslint:disable-next-line:no-shadowed-variable
            let addonTemIndex = -1;
            this.hasLegacy = false;
            this.subscriptions.forEach((subscription, baseIndex) => {

              if (!this.hasLegacy && subscription?.baseSubscription?.out_charge_type == 'SEAT') {
                this.hasLegacy = true;
              }

              subscription.baseSubscription.editMpnIdValue = subscription.baseSubscription.out_mpnid;
              subscription.baseSubscription.editMpnBool = false;
              subscription.baseSubscription.editDescValue = subscription.baseSubscription.out_sub_description;
              subscription.baseSubscription.editDescBool = false;
              subscription.baseSubscription.originalMpnId = subscription.baseSubscription.out_mpnid;
              subscription.baseSubscription.originalDesc = subscription.baseSubscription.out_sub_description;
              subscription.baseSubscription.out_pendingMessage = '';
              let originalBaseQtyPair = {} as KeyValuePair;
              originalBaseQtyPair.id = subscription.baseSubscription.out_subscription_id;
              originalBaseQtyPair.value = subscription.baseSubscription.out_qty;
              this.originalBaseQty.push(originalBaseQtyPair);


              let originalBaseActivePair = {} as KeyValuePair;
              originalBaseActivePair.id = subscription.baseSubscription.out_subscription_id;
              originalBaseActivePair.value = subscription.baseSubscription.out_status_desc == 'Active';
              this.originalBaseActive.push(originalBaseActivePair);

              subscription.baseSubscription.out_price_number = this.cs.toNumber(subscription.baseSubscription.out_price);
              if (subscription.baseSubscription.out_status_desc === 'Active') {
                subscription.baseSubscription.out_activeSuspend = true;
                $(`#${subscription.baseSubscription.out_subscription_id} input[type="checkbox"]`).prop('checked', true);
                this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(subscription.baseSubscription.out_amount)).toString();
              } else {
                this.calculateTotalForNCE(subscription.baseSubscription);
                subscription.baseSubscription.out_activeSuspend = false;
                $(`#${subscription.baseSubscription.out_subscription_id} input[type="checkbox"]`).prop('checked', false);
              }

              let originalAddOnQtyItem = {} as AddOnKeyValuePair;
              originalAddOnQtyItem.id = subscription.baseSubscription.out_subscription_id;
              let originalAddOnQtyList = [];

              let originalAddOnActiveItem = {} as AddOnKeyValuePair;
              originalAddOnActiveItem.id = subscription.baseSubscription.out_subscription_id;
              let originalAddOnActiveList = [];

              subscription.addOnSubscription.forEach((addOn) => {
                if (!this.hasLegacy && addOn?.out_charge_type == 'SEAT') {
                  this.hasLegacy = true;
                }
                addOn.out_pendingMessage = '';
                const addonQtyTemp = { baseIndex: baseIndex, qty: addOn.out_qty };

                let originalAddOnQty = {} as KeyValuePair;
                originalAddOnQty.id = addOn.out_subscription_id;
                originalAddOnQty.value = addOn.out_qty;
                originalAddOnQtyList.push(originalAddOnQty);

                //this.originalAddonQty.push(addonQtyTemp);

                let originalAddOnActive = {} as KeyValuePair;
                originalAddOnActive.id = addOn.out_subscription_id;
                originalAddOnActive.value = addOn.out_status_desc == 'Active' && subscription.baseSubscription.out_status_desc == 'Active';
                originalAddOnActiveList.push(originalAddOnActive);

                addOn.out_price_number = this.cs.toNumber(addOn.out_price);

                if (addOn.out_status_desc === 'Active') {
                  addOn.out_activeSuspend = true;
                  const addonActiveSuspendTemp = { baseIndex: baseIndex, activeSuspend: addOn.out_activeSuspend };
                  //this.originalAddonActive.push(addonActiveSuspendTemp);
                  $(`#${addOn.out_subscription_id} input[type="checkbox"]`).prop('checked', true);
                  this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(addOn.out_amount)).toString();
                } else {
                  this.calculateTotalForNCE(addOn);
                  addOn.out_activeSuspend = false;
                  const addonActiveSuspendTemp = { baseIndex: baseIndex, activeSuspend: addOn.out_activeSuspend };
                  //this.originalAddonActive.push(addonActiveSuspendTemp);
                  $(`#${addOn.out_subscription_id} input[type="checkbox"]`).prop('checked', false);
                }
              });

              originalAddOnQtyItem.value = originalAddOnQtyList;
              this.originalAddonQty.push(originalAddOnQtyItem);

              originalAddOnActiveItem.value = originalAddOnActiveList;
              this.originalAddonActive.push(originalAddOnActiveItem);

              if (this.subscriptionActions.length) {
                this.subscriptionActions.forEach(subscriptionAction => {
                  if (!subscriptionAction.out_error_message) {
                    if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id) {
                      subscription.baseSubscription.out_status = subscriptionAction.out_status;
                      subscription.baseSubscription.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                      subscription.baseSubscription.out_action_status = true;
                      if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY') {
                        subscription.baseSubscription.out_activeSuspend = false;
                        subscription.baseSubscription.out_status = 'XX';
                      } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY') {
                        subscription.baseSubscription.out_activeSuspend = true;
                        var orginalBaseActiveStatus = this.originalBaseActive.find(x => x.id == subscription.baseSubscription.out_subscription_id).value;

                        if (subscription.baseSubscription.out_activeSuspend === orginalBaseActiveStatus) {
                          subscription.baseSubscription.out_status = '';
                        } else {
                          subscription.baseSubscription.out_status = 'PR';
                        }
                      }
                    } else {
                      subscription.baseSubscription.out_action_status = false;
                    }
                    switch (subscriptionAction.out_key) {
                      case 'CREATE': { subscription.baseSubscription.out_pendingMessage = 'Pending Order Creation'; break; }
                      case 'QTY': { subscription.baseSubscription.out_pendingMessage = 'Pending Qty Change to ' + subscriptionAction.out_value; break; }
                      case 'MPNID': { subscription.baseSubscription.out_pendingMessage = 'Pending MPN ID Change to ' + subscriptionAction.out_value; break; }
                      case 'REF': { subscription.baseSubscription.out_pendingMessage = 'Pending Reference Change to ' + subscriptionAction.out_value; break; }
                      case 'SUSPEND':
                        {
                          subscription.baseSubscription.out_pendingMessage = 'Pending Suspension ';
                          break;
                        }
                      case 'REACTIVATE':
                        {
                          subscription.baseSubscription.out_pendingMessage = 'Pending Reactivation ';
                          break;
                        }
                    }
                  }
                });
                subscription.addOnSubscription.forEach((addOn) => {
                  addonTemIndex++;
                  this.subscriptionActions.forEach(subscriptionAction => {
                    if (!subscriptionAction.out_error_message) {
                      if (subscription.baseSubscription.out_status !== 'XX' && subscriptionAction.out_subscription_id !== subscription.baseSubscription.out_subscription_id) {
                        if (subscriptionAction.out_subscription_id === addOn.out_subscription_id) {
                          addOn.out_status = subscriptionAction.out_status;
                          addOn.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                          addOn.out_action_status = true;
                          if (subscription.baseSubscription.out_activeSuspend) {
                            if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY') {
                              addOn.out_activeSuspend = false;
                              addOn.out_status = 'XX';
                            } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY') {
                              addOn.out_activeSuspend = true;


                              let originalAddOnActiveSuspendBase = this.originalAddonActive.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                              let originalAddOnActiveSuspend = originalAddOnActiveSuspendBase.value.find(x => x.id == addOn.out_subscription_id).value;

                              if (addOn.out_activeSuspend === originalAddOnActiveSuspend) {
                                addOn.out_status = '';
                              } else {
                                addOn.out_status = 'PR';
                              }
                            }
                          } else {
                            addOn.out_activeSuspend = false;
                            addOn.out_status = 'XX';
                          }
                        } else {
                          addOn.out_action_status = false;
                        }
                      } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscriptionAction.out_value === 'XX') {
                        addOn.out_status_desc = 'Pending Base Suspended';
                        addOn.out_activeSuspend = false;
                        $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                      } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscriptionAction.out_value !== 'XX') {
                        addOn.out_status_desc = 'Base Suspended';
                        addOn.out_activeSuspend = false;
                        $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                      } else {
                        addOn.out_status = 'XX';
                        addOn.out_activeSuspend = false;
                        addOn.out_status_desc = 'Base Pending Suspended';
                        $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                      }
                      switch (subscriptionAction.out_key) {
                        case 'CREATE': { addOn.out_pendingMessage = 'Pending Order Creation'; break; }
                        case 'QTY': { addOn.out_pendingMessage = 'Pending Qty Change to ' + subscriptionAction.out_value; break; }
                        case 'MPNID': { addOn.out_pendingMessage = 'Pending MPN ID Change to ' + subscriptionAction.out_value; break; }
                        case 'REF': { addOn.out_pendingMessage = 'Pending Reference Change to ' + subscriptionAction.out_value; break; }
                        case 'SUSPEND':
                          {
                            addOn.out_pendingMessage = 'Pending Suspension ';
                            break;
                          }
                        case 'REACTIVATE':
                          {
                            addOn.out_pendingMessage = 'Pending Reactivation ';
                            break;
                          }
                      }
                    }
                  });
                });
              } else {
                subscription.baseSubscription.out_action_status = false;
                subscription.addOnSubscription.forEach(addOn => {
                  addOn.out_action_status = false;
                  if (subscription.baseSubscription.out_status === 'XX') {
                    addOn.out_status_desc = 'Base Suspended';
                    addOn.out_activeSuspend = false;
                    $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                  }
                });
              }
            });
            this.manageService.monitorExistingCSPSubscrptions([...this.subscriptions]);
          },
            (error: any) => {
              console.error(error);
            });
        });
      }
    });
  }

  validateMpnId(mpnIDs: string[], items: CSPModifySubscriptionViewModel[]) {
    this.checkMpnId = false;
    this.showMpnIdloading = true;
    let validFlag = true;
    const errorIdArray = [];

    items.forEach(item => {
      if (item.stockGroup === '85CU') {
        // checks to exclude if already have 17G
        this.isToCheckOwnerEmail = true;
        const existingAzurePlan = this.subscriptions.find(x => x.baseSubscription.out_stock_code === 'DZH318Z0BPS6:0001' && x.baseSubscription.out_mpnid === item.mpnId);
        const pendingAzurePlan = this.annuityItemsPendingList.find(x => x.stockCode === 'DZH318Z0BPS6:0001' && x.mpn === item.mpnId);
        if (existingAzurePlan && pendingAzurePlan) {
          this.cs.implementToast('Only one Azure Plan is allowed per tenant with same partner Id', 'Error');
          this.showMpnIdloading = false;
          return;
        }
        // checks to exclude if already have traditional azure sku
        const existingAzureGlobal = this.subscriptions.find(x => x.baseSubscription.out_stock_code.includes('CSP10MS-AZR-0145') && x.baseSubscription.out_mpnid === item.mpnId);
        if (existingAzureGlobal && pendingAzurePlan) {
          this.cs.implementToast('There is an Azure Offer already existing for this partner Id, please use transition workflow to Azure Plan', 'Error');
          this.showMpnIdloading = false;
          return;
        }
        // this.checkMpnId = false;
      }
    });

    this.cs.implementToast('Verifying MPN ID ...', 'Info');

    mpnIDs.forEach((mpnId, index) => {
      this.manageService.GetPartnerByMPNId(mpnId).subscribe((res: MnpIdAipiResponse) => {
        // this.checkMpnId = false;
        if (res.result === 'Success') {
          this.cs.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
          this.manageService.GetMPAStatusByMPNId(mpnId).subscribe((result: MnpIdAipiResponse) => {
            this.checkMpnId = true;
            if (result.status === false) {
              // this.checkMpnId = result.status;
              this.cs.implementToast('Please check Microsoft Partner Agreement status with partner_id ' + mpnId, 'Error', true);
              this.cs.showValidator('#' + mpnId, 'Please check MPA status with MPN ID: ' + mpnId, 'right', 'error');
              this.showMpnIdloading = false;
              validFlag = false;
            } else {
              // this.checkMpnId = result.status;
              this.showMpnIdloading = false;

              if (validFlag && (index === mpnIDs.length - 1)) {  // check the last MPN ID then update subscriptions
                this.openConfirmPendingModal();
              }
            }

          });
        } else {
          this.checkMpnId = true;
          this.showMpnIdloading = false;
          validFlag = false;
          errorIdArray.push(mpnId);
          this.cs.implementToast(res.info, 'Error', true);

          if (errorIdArray.length > 0 && (index === mpnIDs.length - 1)) {
            setTimeout(() => {
              errorIdArray.forEach(id => {
                this.cs.showValidator('#' + id, 'Invalid MPN ID: ' + id, 'right', 'error');
              });
            }, 1500);
          }
        }

      },
        (error: any) => {
          console.error(error);
        }
      );
    });

  }

  confirmAzureRiList(): void {
    this.totalAzureRiPendingPrice = 0;
    this.azureRIItemsPendingList.forEach(item => {
      if (item.isMonthly) {
        item.totalPrice = this.cs.toNumber(item.monthlyPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(item.quantity);
        this.totalAzureRiPendingPrice += this.cs.toNumber(item.monthlyPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(item.quantity);
      } else {
        item.totalPrice = this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(item.quantity);
        this.totalAzureRiPendingPrice += this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(item.quantity);
      }

    });
    const dialogRef = this.dialog.open(ConfirmAzureRiComponent, {
      width: '650px',
      panelClass: 'mat-dialog-wrapper',
      data: { totalAzureRiPendingPrice: this.totalAzureRiPendingPrice }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.continueSaveAzureRiList = [];
        if (this.azureRIItemsPendingList.length) {
          this.azureRIItemsPendingList.forEach(item => {
            this.continueSaveAzureRiItem = {} as CSPPerpetualModifyViewModel;
            this.continueSaveAzureRiItem = {
              tenantId: this.tenantId,
              tenantName: this.details.customer.out_company_name,
              lineType: item.lineType,
              customerReference: result,
              unitPrice: item.itemPrice,
              lineTotal: item.totalPrice.toString(),
              stockCode: item.stockCode,
              description: item.description,
              skuId: item.skuId,
              billingFrequency: item.billingFrequency,
              productId: item.productId,
              catalogItemId: item.catalogItemId,
              qty: item.quantity,
              status: 'PS',
              mpnId: this.cs.parseNPM(item.mpnId),
              lineSeq: '',
              isUpdateSuccessful: true,
              isMonthly: item.isMonthly,
              orderNumber: '',
              message: '',
              subscriptionId: item.subscriptionId,
              scope: item.scope
            };
            this.continueSaveAzureRiList.push(this.continueSaveAzureRiItem);
          });
          this.manageService.CreatePerpetualOrder(this.continueSaveAzureRiList).subscribe((res: PerpetualApiResponse) => {
            this.azureRiApiResponse = res;
            // tslint:disable-next-line:no-shadowed-variable
            const dialogRef = this.dialog.open(FinishAzureRiComponent, {
              width: '650px',
              panelClass: 'mat-dialog-wrapper',
              data: { azureRiApiResponse: this.azureRiApiResponse }
            });

            dialogRef.afterClosed().subscribe(() => {
              this.azureRIItemsPendingList = [];
              this.cspReservedInstanceItems = [];
              // this.loadContent = false;
              this.loadCSPAzureri = false;
              this.manageService.monitorPendingAzureRi([]);
              this.manageService.GetCSPCustomerEntitlmentsView(this.tenantId)
                .subscribe((data: CSPCustomerEntitlementsViewModel[]) => {

                  // data.forEach(element => {

                  //   if (element.entitlementType === 'reservedinstance') {
                  //     this.cspReservedInstanceItems.push(element);
                  //   }

                  // });
                  this.cspReservedInstanceItems = data.filter(element => element.entitlementType === 'reservedinstance');
                  this.manageService.cspReservedInstanceItemsCount$.next(this.cspReservedInstanceItems.length);
                  this.loadCSPAzureri = true;

                },
                  (error: any) => {
                    console.error(error);
                    this.loadCSPAzureri = true;
                  });
              // this.manageService.GetCSPAzureRIItemsView(this.tenantId).subscribe((model: CSPPerpetualItemViewModel) => {
              //   if (model && model.lineItems.length) {
              //     this.azureRIItems = model.lineItems;
              //   }
              //   this.loadContent = true;
              // },
              //   (error: any) => {
              //     this.loadContent = true;
              //     console.error(error);
              //   });
            });
          },
            (error: any) => {
              const azureRiApiResponse = {
                status: 'Fail',
                message: ''
              };
              // tslint:disable-next-line:no-shadowed-variable
              const dialogRef = this.dialog.open(FinishAzureRiComponent, {
                width: '650px',
                panelClass: 'mat-dialog-wrapper',
                data: { azureRiApiResponse: azureRiApiResponse }
              });

              dialogRef.afterClosed().subscribe(() => {
                this.cspReservedInstanceItems = [];
                this.azureRIItemsPendingList = [];
                this.loadCSPAzureri = false;
                this.manageService.monitorPendingAzureRi([]);

                this.manageService.GetCSPCustomerEntitlmentsView(this.tenantId)
                  .subscribe((data: CSPCustomerEntitlementsViewModel[]) => {
                    this.cspReservedInstanceItems = data.filter(element => element.entitlementType === 'reservedinstance');
                    this.manageService.cspReservedInstanceItemsCount$.next(this.cspReservedInstanceItems.length);
                    this.loadCSPAzureri = true;

                  },
                    // tslint:disable-next-line:no-shadowed-variable
                    (error: any) => {
                      console.error(error);
                      this.loadCSPAzureri = true;
                    });
              });
              console.error(error);
            });
        }
      }
    });
  }

  refreshSoftwareSubscription(): void {
    this.manageService.GetCSPSoftwareSubscriptionsView(this.tenantId).subscribe((data: CSPCustomerEntitlementsViewModel[]) => {
      this.cspSoftwareItems = data.filter(element => element.entitlementType === 'software');
      this.loadCSPSoftware = true;
    },
      (error: any) => {
        console.error(error);
        this.loadCSPSoftware = true;
      });
  }
  confirmSoftwareSubscription(): void {
    this.totalSoftwareSubscriptionPendingPrice = 0;
    this.softwareSubscriptionPendingList.forEach(softwareSubscription => {
      softwareSubscription.totalPrice = this.cs.toNumber(softwareSubscription.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(softwareSubscription.quantity);
      this.totalSoftwareSubscriptionPendingPrice += this.cs.toNumber(softwareSubscription.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(softwareSubscription.quantity);
    });
    const dialogRef = this.dialog.open(ConfirmSoftwareComponent, {
      width: '650px',
      panelClass: 'mat-dialog-wrapper',
      data: { totalSoftwareSubscriptionPendingPrice: this.totalSoftwareSubscriptionPendingPrice }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.continueSaveSoftwareSubscriptionList = [];
        if (this.softwareSubscriptionPendingList.length) {
          this.softwareSubscriptionPendingList.forEach(item => {
            this.continueSaveSoftwareSubscriptionItem = {} as CSPPerpetualModifyViewModel;
            this.continueSaveSoftwareSubscriptionItem = {
              tenantId: this.tenantId,
              tenantName: this.details.customer.out_company_name,
              lineType: item.lineType,
              customerReference: result,
              unitPrice: item.itemPrice,
              lineTotal: item.totalPrice.toString(),
              stockCode: item.stockCode,
              description: item.description,
              skuId: item.skuId,
              billingFrequency: item.billingFrequency,
              productId: item.productId,
              catalogItemId: item.catalogItemId,
              qty: item.quantity,
              status: 'PS',
              mpnId: this.cs.parseNPM(item.mpnId),
              lineSeq: '',
              isUpdateSuccessful: true,
              isMonthly: false,
              orderNumber: '',
              message: '',
              subscriptionId: '',
              scope: item.scope
            };
            this.continueSaveSoftwareSubscriptionList.push(this.continueSaveSoftwareSubscriptionItem);
          });
          this.manageService.CreatePerpetualOrder(this.continueSaveSoftwareSubscriptionList).subscribe((res: PerpetualApiResponse) => {
            this.softwareSubscriptionApiResponse = res;
            // tslint:disable-next-line:no-shadowed-variable
            const dialogRef = this.dialog.open(FinishSoftwareComponent, {
              width: '650px',
              panelClass: 'mat-dialog-wrapper',
              data: { softwareSubscriptionApiResponse: this.softwareSubscriptionApiResponse }
            });


            dialogRef.afterClosed().subscribe(() => {

              this.softwareSubscriptionPendingList = [];

              this.cspSoftwareItems = [];

              this.loadCSPSoftware = false;

              this.manageService.monitorPendingSoftware([]);

              this.refreshSoftwareSubscription();
            });
          },
            () => {
              const softwareApiResponse = {
                status: 'Fail',
                message: 'Fail to purchase software'
              };
              // tslint:disable-next-line:no-shadowed-variable
              const dialogRef = this.dialog.open(FinishSoftwareComponent, {
                width: '650px',
                panelClass: 'mat-dialog-wrapper',
                data: { softwareSubscriptionApiResponse: softwareApiResponse }
              });

              dialogRef.afterClosed().subscribe(() => {
                this.cspSoftwareItems = [];
                this.softwareSubscriptionPendingList = [];
                this.manageService.monitorPendingSoftware([]);

                this.loadCSPSoftware = false;

                this.manageService.GetCSPCustomerEntitlmentsView(this.tenantId)
                  .subscribe((data: CSPCustomerEntitlementsViewModel[]) => {


                    this.cspSoftwareItems = data.filter(element => element.entitlementType === 'software');
                    this.cspReservedInstanceItems = data.filter(element => element.entitlementType === 'reservedinstance');
                    this.manageService.cspReservedInstanceItemsCount$.next(this.cspReservedInstanceItems.length);
                    this.loadCSPSoftware = true;
                  },
                    (error: any) => {
                      console.error(error);
                      this.loadCSPSoftware = true;
                    });
              });
            });
        }
      }
    });
  }


  getProductList(productType: string): void {
    this.router.navigate(['AddProducts', productType], { relativeTo: this.activatedRoute });
  }

  getSubscriptionOrderList(): void {
    this.router.navigate(['AddSubscriptions'], { relativeTo: this.activatedRoute });
  }

  getSoftwareSubscriptionList(): void {
    this.router.navigate(['AddSoftware'], { relativeTo: this.activatedRoute });
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  getAzureRiList(): void {
    this.router.navigate(['AddAzureRi'], { relativeTo: this.activatedRoute });
  }

  manageSubscription(subscription: GetCSPSubscription): void {
    this.manageService.upgradeSubscriotionfrom$.next(subscription);
    this.router.navigate(['ManageLicenseSubscriotion/SubscriptionDetails/', { sub: subscription.out_subscription_id }], { relativeTo: this.activatedRoute });
  }

  manageAzureSubscription(subscription: GetCSPSubscription): void {
    this.manageService.upgradeSubscriotionfrom$.next(subscription);
    this.router.navigate(['ManageAzureSubscription/SubscriptionDetails/' + this.tenantId, { sub: subscription.out_subscription_id }], { relativeTo: this.activatedRoute });
  }

  manageSoftware(subscription: CSPCustomerEntitlementsViewModel, idx: number): void {
    this.checkingSoftwareSubscriptionIndex = idx;
    this.manageService.monitorCurrentCSPSoftware(subscription);
  }

  public manageAzureRI(subscription: CSPCustomerEntitlementsViewModel, idx: number): void {
    this.checkingAzureRIIndex = idx;
    this.manageService.monitorCurrentCSPReservedInstance(subscription);
  }

  getAddons(subscription: GetCSPSubscription): void {
    this.router.navigate([`AddAddon/${subscription.out_stock_code}/${subscription.out_subscription_id}`], { relativeTo: this.activatedRoute });
  }

  getPendingMessage(subscription: GetCSPSubscription): GetCSPSubscriptionActions {
    const pendingChange = {} as GetCSPSubscriptionActions;
    pendingChange.out_message = '';
    pendingChange.changeAmount = 0;
    pendingChange.hasChange = false;
    this.subscriptionActions.forEach(subscriptionAction => {
      if (!subscriptionAction.out_error_message) {
        if (subscription.out_subscription_id === subscriptionAction.out_subscription_id) {
          pendingChange.out_status_desc = subscriptionAction.out_status_desc;
          switch (subscriptionAction.out_key) {
            case 'CREATE': { pendingChange.out_message += 'Pending Order Creation '; break; }
            case 'QTY': { pendingChange.out_message += 'Pending Qty Change to ' + subscriptionAction.out_value + ' '; break; }
            case 'MPNID': { pendingChange.out_message += 'Pending MPN ID Change to ' + subscriptionAction.out_value + ' '; break; }
            case 'REF': { pendingChange.out_message += 'Pending Reference Change to ' + subscriptionAction.out_value + ' '; break; }
            case 'SUSPEND':
              {
                pendingChange.out_message += 'Pending Suspension ';
                break;
              }
            case 'REACTIVATE':
              {
                pendingChange.out_message += 'Pending Reactivation ';
                break;
              }
          }
          pendingChange.changeAmount++;
        }
      } else {
        if (subscription.out_subscription_id === subscriptionAction.out_subscription_id) {
          pendingChange.out_status_desc = subscriptionAction.out_status_desc;
          pendingChange.out_message += subscriptionAction.out_error_message + ' ';
          pendingChange.changeAmount++;
        }
      }
    });
    return pendingChange;
  }

  selectMpnId(annuityItem: AnnuityItemsViewModel): void {
    annuityItem.mpn = this.mpnIdSelect;
  }

  selectAddonMpnId(addonItemPending: AnnuityItemsViewModel): void {
    addonItemPending.mpn = this.mpnIdAddonSelect;
  }

  onMPNIdChange(type: string, subscription: GetCSPSubscription, idx?: number, addonIdx?: number): void {
    if (subscription.editMpnIdValue !== subscription.originalMpnId) {
      this.checkMpnId = true;
      //this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(type, subscription, idx, addonIdx);
    } else {
      this.checkMpnId = false;
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(type, subscription, idx, addonIdx);
    //subscription.editMpnBool = false;
  }

  confirmMpnID(mpnId: string, chargeType?: string, subscription?: CSPSubscriptions, index?: number,
    addonIndex?: number, editExisting?: false): void {
    this.checkMpnId = false;
    this.showMpnIdloading = true;
    mpnId = this.cs.parseNPM(subscription == null ? mpnId : subscription.baseSubscription.editMpnIdValue);
    chargeType = subscription == null ? chargeType : subscription.baseSubscription.out_charge_type;

    if (chargeType === 'USAGE') {
      // checks to exclude if already have 17G
      this.isToCheckOwnerEmail = true;
      const existingAzurePlan = this.subscriptions.find(x => x.baseSubscription.out_stock_code === 'DZH318Z0BPS6:0001' && x.baseSubscription.out_mpnid === mpnId);
      const pendingAzurePlan = this.annuityItemsPendingList.find(x => x.stockCode === 'DZH318Z0BPS6:0001' && x.mpn === mpnId);

      if (existingAzurePlan && pendingAzurePlan) {
        this.cs.implementToast('Only one Azure Plan is allowed per tenant with same partner Id', 'Error');
        this.showMpnIdloading = false;
        return;
      }

      // checks to exclude if already have traditional azure sku
      const existingAzureGlobal = this.subscriptions.find(x => x.baseSubscription.out_stock_code.includes('CSP10MS-AZR-0145') && x.baseSubscription.out_mpnid === mpnId);
      if (existingAzureGlobal && pendingAzurePlan) {
        this.cs.implementToast('There is an Azure Offer already existing for this partner Id, please use transition workflow to Azure Plan', 'Error');
        this.showMpnIdloading = false;
        return;
      }
      this.checkMpnId = false;
    }

    this.cs.implementToast('Verifying MPN ID ...', 'Info');
    // call getPartnerByMPNId api
    this.manageService.GetPartnerByMPNId(mpnId).subscribe((res: MnpIdAipiResponse) => {
      this.checkMpnId = false;
      if (res.result === 'Success') {
        // call getMPAStatusbyMpnId api
        this.manageService.GetMPAStatusByMPNId(mpnId).subscribe((result: MnpIdAipiResponse) => {
          if (result.status === false) {
            this.checkMpnId = result.status;
            this.cs.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
            this.showMpnIdloading = false;
          } else {
            if (editExisting) {
              this.isToCheckEditMNPId = true;
              this.editMpnId(subscription, index, addonIndex);
            } else {
              this.isToCheckEditMNPId = false;
            }
            this.checkMpnId = result.status;
            this.showMpnIdloading = false;
          }
        });
      } else {
        this.cs.implementToast(res.info, 'Error', true);
        this.checkMpnId = false;
        this.showMpnIdloading = false;
      }
    },
      (error: any) => {
        console.error(error);
      }
    );
  }
  editMpnId(subscription: CSPSubscriptions, index: number, addonIndex: number): void {
    subscription.baseSubscription.editMpnBool = false;
    if (subscription.baseSubscription.editMpnIdValue) {
      subscription.baseSubscription.out_mpnid = subscription.baseSubscription.editMpnIdValue;
    } else {
      subscription.baseSubscription.editMpnIdValue = subscription.baseSubscription.out_mpnid;
    }
    if (this.subscriptionsPendingChange.length) {
      if (!this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.baseSubscription.out_subscription_id).length) {
        if (subscription.baseSubscription.originalMpnId !== subscription.baseSubscription.out_mpnid) {
          this.subscriptionsPendingChange.push(subscription.baseSubscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.baseSubscription.out_subscription_id);
        }
      } else {
        this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.baseSubscription.out_subscription_id)[0].out_mpnid = subscription.baseSubscription.out_mpnid;
      }
    } else {
      if (subscription.baseSubscription.originalMpnId !== subscription.baseSubscription.out_mpnid) {
        this.subscriptionsPendingChange.push(subscription.baseSubscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.baseSubscription.out_subscription_id);
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, addonIndex);
    if (this.pendingRowConfirmStatus) {
      $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else {
      $(`#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
    }

  }

  editDesc(subscription: CSPSubscriptions, index: number, addonIndex: number): void {
    subscription.baseSubscription.editDescBool = false;
    if (subscription.baseSubscription.editDescValue) {
      subscription.baseSubscription.out_sub_description = subscription.baseSubscription.editDescValue;
    } else {
      subscription.baseSubscription.editDescValue = subscription.baseSubscription.out_sub_description;
    }
    if (this.subscriptionsPendingChange.length) {
      if (!this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.baseSubscription.out_subscription_id).length) {
        if (subscription.baseSubscription.originalDesc !== subscription.baseSubscription.out_sub_description) {
          this.subscriptionsPendingChange.push(subscription.baseSubscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.baseSubscription.out_subscription_id);
        }
      } else {
        this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.baseSubscription.out_subscription_id)[0].out_sub_description = subscription.baseSubscription.out_sub_description;
      }
    } else {
      if (subscription.baseSubscription.originalDesc !== subscription.baseSubscription.out_sub_description) {
        this.subscriptionsPendingChange.push(subscription.baseSubscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.baseSubscription.out_subscription_id);
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, addonIndex);
    if (this.pendingRowConfirmStatus) {
      $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else {
      $(`#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
    }

  }

  enableEditMpn(subscription: CSPSubscriptions): void {
    subscription.baseSubscription.editMpnBool = true;
    subscription.baseSubscription.editDescBool = false;
  }

  enableEditDesc(subscription: CSPSubscriptions): void {
    subscription.baseSubscription.editMpnBool = false;
    subscription.baseSubscription.editDescBool = true;
  }

  editAddonMpnId(subscription: GetCSPSubscription, index: number, addonIndex: number): void {
    subscription.editMpnBool = false;
    if (subscription.editMpnIdValue) {
      subscription.out_mpnid = subscription.editMpnIdValue;
    } else {
      subscription.editMpnIdValue = subscription.out_mpnid;
    }
    if (this.subscriptionsPendingChange.length) {
      if (!this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id).length) {
        if (subscription.originalMpnId !== subscription.out_mpnid) {
          this.subscriptionsPendingChange.push(subscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
        }
      } else {
        this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id)[0].out_mpnid = subscription.out_mpnid;
      }
    } else {
      if (subscription.originalMpnId !== subscription.out_mpnid) {
        this.subscriptionsPendingChange.push(subscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, index, addonIndex);
    if (this.pendingRowConfirmStatus) {
      $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else {
      $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
    }
  }

  editAddonDesc(subscription: GetCSPSubscription, index: number, addonIndex: number): void {
    subscription.editDescBool = false;
    if (subscription.editDescValue) {
      subscription.out_sub_description = subscription.editDescValue;
    } else {
      subscription.editDescValue = subscription.out_sub_description;
    }
    if (this.subscriptionsPendingChange.length) {
      if (!this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id).length) {
        if (subscription.originalDesc !== subscription.out_sub_description) {
          this.subscriptionsPendingChange.push(subscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
        }
      } else {
        this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id)[0].out_sub_description = subscription.out_sub_description;
      }
    } else {
      if (subscription.originalDesc !== subscription.out_sub_description) {
        this.subscriptionsPendingChange.push(subscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, index, addonIndex);
    if (this.pendingRowConfirmStatus) {
      $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else {
      $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
    }

  }

  enableAddonEditMpn(subscription: GetCSPSubscription): void {
    subscription.editMpnBool = true;
    subscription.editDescBool = false;
  }

  enablePendingAddonEditMpn(pendingAddOn: AnnuityItemsViewModel): void {
    pendingAddOn.editMPN = true;
  }

  enableAddonEditDesc(subscription: GetCSPSubscription): void {
    subscription.editMpnBool = false;
    subscription.editDescBool = true;
  }

  removeAnnuityPendingItem(annuityItemPending: AnnuityItemsViewModel): void {
    this.annuityItemsPendingList = this.annuityItemsPendingList.filter(annuityItem => annuityItem.stockCode !== annuityItemPending.stockCode);
    this.manageService.monitorPendingSubscriptions(this.annuityItemsPendingList);
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('', null, 0, 0);
  }

  removeAddonPendingItem(subscription: CSPSubscriptions, index: number): void {
    subscription.pendingAddOnSubscription.splice(index, 1);
    this.totalPriceChange = this.calculateTotalPriceChange();
    this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
    if (!this.pendingTotal) {
      this.totalPriceChange = 0;
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('', null, 0, 0);
  }
  // removeCspPerpetualItemsPending(pendingItem: CSPPerpetualItemsViewModel): void {
  //   this.cspPerpetualItemsPending = this.cspPerpetualItemsPending.filter(item => item.stockCode !== pendingItem.stockCode);
  //   this.manageService.monitorPendingPerpetualItems(this.cspPerpetualItemsPending);
  // }

  removeAzureRIItemsPending(pendingItem: CSPPerpetualItemsViewModel): void {
    // this.azureRIItemsPendingList = this.azureRIItemsPendingList.filter(item => item.productId + item.skuId != pendingItem.productId + pendingItem.skuId);
    this.azureRIItemsPendingList.splice(this.azureRIItemsPendingList.indexOf(pendingItem), 1);
    this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
  }

  removeSoftwareSubscriptionPendingList(pendingItem: CSPPerpetualItemsViewModel): void {
    this.softwareSubscriptionPendingList = this.softwareSubscriptionPendingList.filter(item => item.stockCode !== pendingItem.stockCode);
    this.manageService.monitorPendingSoftware(this.softwareSubscriptionPendingList);
  }

  showSwitchButton(subscriptionId: string): boolean {
    this.subscriptionActionExist = this.subscriptionActions.filter(subscriptionAction => subscriptionAction.out_subscription_id === subscriptionId);
    if (this.subscriptionActionExist[0]) {
      if (this.subscriptionActionExist[0].out_error_message) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }


  toggleRenewalFreq(subscription: GetCSPSubscription) {
    subscription.editRenewalFreq = !subscription.editRenewalFreq;
  }

  toggleBillingFreq(subscription: GetCSPSubscription) {
    subscription.editBillingFreq = !subscription.editBillingFreq;
  }

  checkSubInProgress(subscription: GetCSPSubscription): boolean {
    return subscription.out_status_desc.includes('In Progress')
  }

  checkBillingPlan(subscription: GetCSPSubscription): boolean {
    // Annual Subs: P1Y - they can pay monthly or yearly - 12 months Expiry
    let [term, ...rest] = subscription.out_stock_code.split(':');

    if (term == 'P1Y') {
      return true;
    } else {
      return false;
    }

  }


  displayFn(freq: string): string {
    return freq == '1' ? 'Monthly' : 'Annual'
  }

  getAutoRenewDate(subscription: GetCSPSubscription): string {
    let renew_date = '';
    if (subscription.out_expiry_date) {
      renew_date = format(addDays(Number(subscription.out_expiry_date), 1), 'DD-MMM-YYYY');
    }
    return renew_date.toUpperCase();
  }

  async UpdateSubscriptionCycle(termDuration: string, subscription: GetCSPSubscription, action: string) {

    let title, text: string;
    let billing: number;

    if (action == 'RENEWAL') {
      title = 'Confirm Renewal';
      if (termDuration == 'P1Y') {
        text = 'Are you sure to change the subscription renewal to annually?';
      } else {
        text = 'Are you sure to change the subscription renewal to monthly?';
      }

      //get billing
      const [term, productId, skuId, billingId, promotion] = subscription.out_stock_code.split(':');

      let targetStockCode: string;

      if (term == 'P1Y') {
        targetStockCode = ["P1M", productId, skuId, billingId, promotion].join(":");
      } else if (term == 'P1M') {
        targetStockCode = ["P1Y", productId, skuId, billingId, promotion].join(":");
      }

      const response = await fetch('Manage/GetProductPricingList', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([targetStockCode]),
      });

      let stockPriceList = await response.json();


      billing = Number(stockPriceList[0].out_current_price) + Number(subscription.out_price);

    } else if (action == 'BILLING') {
      title = 'Confirm Billing Plan';
      if (termDuration == 'P1Y') {
        text = 'Are you sure to change the subscription billing plan to annually?';
      } else {
        text = 'Are you sure to change the subscription billing plan to monthly?';
      }
    }

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title: title, text: text, billing: billing }
    });

    dialogRef.afterClosed().subscribe(result => {
      // Triennial =5 Monthly=1  Annual=2
      if (result) {

        let productTerm = {} as ProductTerm;

        let [term, productId, skuId] = subscription.out_stock_code.split(':');

        productTerm.productId = productId;

        productTerm.skuId = skuId;

        if (action == 'RENEWAL') {

          productTerm.termDuration = termDuration;

          productTerm.billingCycle = term == 'P1Y' ? 2 : 1;

        } else if (action == 'BILLING') {

          productTerm.termDuration = term;

          productTerm.billingCycle = termDuration == 'P1Y' ? 2 : 1;

        }


        productTerm.availabilityId = '';

        this.showMpnIdloading = true;

        this.manageService.UpdateSubscriptionCycle(this.tenantId, subscription.out_subscription_id.toLowerCase(), subscription.out_stock_code.toLocaleLowerCase(), subscription.out_offer_uri.toLocaleLowerCase(), Number(subscription.out_confirmed_qty), action, subscription.out_expiry_date, productTerm).subscribe(() => {
          subscription.editRenewalFreq = false;
          this.showMpnIdloading = false;
          this.refetchCSPItemsView();
        },
          (error) => {
            this.cs.implementToast(error, "Error");
            subscription.editRenewalFreq = false;
            this.showMpnIdloading = false;
          });
      }
    });



  }

  pendingRenewalCheck(statusDesc: string, status = 'Renewal In Progress'): number {
    return statusDesc == status ? 2 : 1;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    if (this.isInCustiomerMenu()) {
      this.customerService.currentCustomerWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: DDCustomer) => { 
        this.router.navigateByUrl("/customers/" + res?.id);
        $('#levelOne').animate({ scrollLeft: 0 }, 400);
      });
    } else {
      this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/' + this.programType);
      $('#levelOne').animate({ scrollLeft: 0 }, 400);
    }
  }

  estimateCost(baseSubscription: GetCSPSubscription): void {
    baseSubscription.loadingStatus = true;
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  filterSoftwareSubscriptionItems(): void {
    this.softwareSubscriptionAddItemsFilter = this.softwareSubscriptionAddItems.filter(softwareSubscription => softwareSubscription.title.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()) || softwareSubscription.stockCode.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()));
  }

  checkSubscriptionOwnerEmailStatus(annuityItemPending: AnnuityItemsViewModel) {
    this.showEmailloading = true;
    this.isToCheckOwnerEmail = true;
    this.checkEmail = false;
    if (annuityItemPending.ownerEmail) {
      this.cs.implementToast('Verifying owner email within tenant domain....', 'Info');
      this.manageService.CheckSubscriptionOwnerEmailStatus(annuityItemPending.ownerEmail, this.tenantId).subscribe((res: SubscriptionApiResponse) => {
        if (res.status === 'Success') {
          annuityItemPending.ownerEmailStatus = true;
          // this.cs.implementToast(res.message, "Success");
          this.showEmailloading = false;
          this.checkEmail = true;
          // this.cs.showSuccess(`#${annuityItemPending.stockCode}email`, res.message, "right");
        } else {
          annuityItemPending.ownerEmailStatus = false;
          this.cs.implementToast(res.message, 'Error');
          this.checkEmail = false;
          this.showEmailloading = false;
          // this.cs.showError(`#${annuityItemPending.stockCode}email`, res.message, "right");
        }
      },
        (error: any) => {
          console.error(error);
        });
    } else {
      annuityItemPending.ownerEmailStatus = false;
      this.cs.implementToast('Please provide subscription owner email address', 'Info');
      this.showEmailloading = false;
      this.checkEmail = false;
    }
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  FilterStatus(isAzureTable: boolean = false): void {
    if (isAzureTable) {
      this.azureUsageSearchStatusList = [];
      this.azureUsageSearchStatusList = this.azureUsageSubsSelectedStatus;
    } else {
      this.searchStatusList = [];
      this.searchStatusList = this.selectedStatus;
    }
  }

  onSelectAll(isAzureTable: boolean = false): void {
    if (isAzureTable) {
      this.azureUsageSubsSelectedStatus = this.statusList.map(x => x.value);
      this.azureUsageSearchStatusList = this.azureUsageSubsSelectedStatus;
    } else {
      this.selectedStatus = this.statusList.map(x => x.value);
      this.searchStatusList = this.selectedStatus;
    }
  }

  onClearAll(isAzureTable: boolean = false): void {
    if (isAzureTable) {
      this.azureUsageSubsSelectedStatus = [];
      this.azureUsageSearchStatusList = this.azureUsageSubsSelectedStatus;
    } else {
      this.selectedStatus = [];
      this.searchStatusList = this.selectedStatus;
    }
  }

  onClearRenewalOptions(): void {
    this.selectedRenewalOptions = '';
  }

  closePopup(): void {
    this.ngProgress.done();
  }

  closeAgreementPopup(): void {
    if (this.subscriptionResponse.status === 'Fail') {
      this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP');
    }
    $('#updateagreement').foundation('close');
    this.ngProgress.done();
  }

  private getNcePendingTotal(subscription: GetCSPSubscription): number {

    let billingChange = 0;

    const today = new Date;

    const days_left = differenceInDays(new Date(subscription.out_expiry_date), today) + 2;

    const total_days = differenceInDays(new Date(subscription.out_expiry_date), new Date(subscription.out_start_usage)) + 1;

    //adding license
    if (Number(subscription.out_qty) >= Number(subscription.out_confirmed_qty)) {

      billingChange = Number(subscription.out_qty) * Number(subscription.out_price) + (Number(subscription.out_price) * (days_left / total_days) * (Number(subscription.out_qty) - Number(subscription.out_confirmed_qty)));
    } else {
      //reducing license
      const pruchase_date = new Date(subscription.out_process_datetime);

      const last_refund_date = addDays(pruchase_date, 3);

      if (isBefore(today, last_refund_date)) {

        billingChange = Number(subscription.out_qty) * Number(subscription.out_price) + (Number(subscription.out_price) * (days_left / total_days) * (Number(subscription.out_confirmed_qty) - Number(subscription.out_qty)));

      } else {

        billingChange = Number(subscription.out_qty) * Number(subscription.out_price);

      }

    }

    return billingChange;

  }

  private calculateTotalPriceChange(): number {
    let totalPriceChange = 0;
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach(subscription => {
        if (subscription.baseSubscription.out_status_desc === 'Active' && subscription.baseSubscription.out_activeSuspend && subscription.baseSubscription.out_stock_group !== '85CU') {

          if (subscription.baseSubscription.out_charge_type == 'NCE') {

            totalPriceChange += this.getNcePendingTotal(subscription.baseSubscription);

          } else {
            // non-nce calculation
            totalPriceChange += this.cs.toNumber(subscription.baseSubscription.out_qty) * this.cs.toNumber(subscription.baseSubscription.out_price);
          }

        } else if (subscription.baseSubscription.out_status_desc === 'Active' && subscription.baseSubscription.out_activeSuspend && subscription.baseSubscription.out_stock_group === '85CU') {
          totalPriceChange += this.cs.toNumber(subscription.baseSubscription.out_amount);
        }
        subscription.addOnSubscription.forEach(addOn => {
          if (addOn.out_status_desc === 'Active' && addOn.out_activeSuspend) {
            if (addOn.out_charge_type == 'NCE') {
              totalPriceChange += this.getNcePendingTotal(addOn);
            } else {
              totalPriceChange += this.cs.toNumber(addOn.out_qty) * this.cs.toNumber(addOn.out_price);
            }
          }
        });
        //add each pending addon
        if (subscription.pendingAddOnSubscription && subscription.pendingAddOnSubscription.length > 0) {
          subscription.pendingAddOnSubscription.forEach(addon => {
            totalPriceChange += this.cs.toNumber(addon.quantity) * this.cs.toNumber(addon.itemPrice.replace('$', ''));
          });
        }
      });
    }

    this.annuityItemsPendingList.forEach(subscription => {
      totalPriceChange += this.cs.toNumber(subscription.quantity) * this.cs.toNumber(subscription.itemPrice.replace('$', ''));
    });

    return totalPriceChange;
  }

  // private toggleNCEAutoRenew(subscription: GetCSPSubscription, autoRenew: boolean) {
  //   this.manageService.UpdateSubscriptionRenew(this.tenantId.toLocaleLowerCase(), subscription.out_subscription_id.toLocaleLowerCase(), subscription.out_stock_code.toLocaleLowerCase(), autoRenew, subscription.out_expiry_date).pipe(
  //   );
  // }

  private toggleRowConfirmStatus(type: string, subscription: GetCSPSubscription, index: number, addonIndex: number): boolean {
    let pendingConfirmStatus = false;

    if (type === 'base') {
      let originalBaseQtyItem = this.originalBaseQty.find(e => e.id == subscription.out_subscription_id).value;
      let originalBasActiveItem = this.originalBaseActive.find(e => e.id == subscription.out_subscription_id).value;
      //if (subscription.out_qty === originalBaseQtyItem && subscription.out_activeSuspend === this.originalBaseActive[index] && subscription.originalDesc === subscription.out_sub_description && subscription.originalMpnId === subscription.editMpnIdValue) {
      if (subscription.out_qty === originalBaseQtyItem && subscription.out_activeSuspend === originalBasActiveItem && subscription.originalDesc === subscription.out_sub_description && subscription.originalMpnId === subscription.editMpnIdValue) {
        pendingConfirmStatus = false;
      } else {
        pendingConfirmStatus = true;
      }
    } else if (type === 'addon') {

      let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.out_parent_subscription);
      let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == subscription.out_subscription_id).value;

      let originalAddOnActiveSuspendBase = this.originalAddonActive.find(x => x.id == subscription.out_parent_subscription);
      let originalAddOnActiveSuspend = originalAddOnActiveSuspendBase.value.find(x => x.id == subscription.out_subscription_id).value;

      if (subscription.out_qty === originalAddOnQty && subscription.out_activeSuspend === originalAddOnActiveSuspend && subscription.originalDesc === subscription.out_sub_description && subscription.originalMpnId === subscription.editMpnIdValue) {
        pendingConfirmStatus = false;
      } else {
        pendingConfirmStatus = true;
      }
    }

    //update pendingConfirmStatus for each base and addon
    if (subscription) {
      subscription.pendingRowConfirmStatus = pendingConfirmStatus;
    }
    //set up hasSubPending variable
    let pending = false;
    // if (this.annuityItemsPendingList.length > 0 || this.addonListPendingList.length > 0) {
    //   pending = true;
    // } else {
    if (this.annuityItemsPendingList.length > 0 || this.subscriptions.some((subscrioption) => subscrioption.pendingAddOnSubscription && subscrioption.pendingAddOnSubscription.length > 0)) {
      pending = true;
    } else {
      for (let i = 0; i < this.subscriptions.length; i++) {
        if (this.subscriptions[i].baseSubscription.pendingRowConfirmStatus || this.subscriptions[i].addOnSubscription.some((addon) => {
          return addon.pendingRowConfirmStatus == true;
        })) {
          pending = true;
          break;
        }
      }
    }
    this.hasSubPending = pending;
    if (pendingConfirmStatus && subscription) {
      $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else if (!pendingConfirmStatus && subscription) {
      $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
    }

    // if (this.annuityItemsPendingList.length || this.addonListPendingList.length) {
    //   pendingConfirmStatus = true;
    // }

    // if (this.annuityItemsPendingList.length || this.subscriptions.some((subscrioption) => subscrioption.pendingAddOnSubscription && subscrioption.pendingAddOnSubscription.length > 0)) {
    //   pendingConfirmStatus = true;
    // }

    return pendingConfirmStatus;
  }


  getCmsById(id, viewcms) {
    if (!id) { id = '5c9828b40ebfa3188cc9dc96'; }
    this.cmsserivce.getCmsById(id)
      .subscribe(res => {
        if (viewcms) {
          this.viewCms = res.count;
        } else {
          this.cms = res.count;
        }
      });
  }

  getBackgroundColor(i) {
    let ret = '#FBFBFB';
    switch (i) {
      case 0:
        ret = '#FBFBFB';
        break;
      case 1:
        ret = '#F7F7F7';
        break;
      case 2:
        ret = '#F4F4F4';
        break;
      case 3:
        ret = '#EEEEEE';
        break;
    }
    return ret;
  }

  viewNavigation(i, id) {
    this.viewNavIndex = i;
    this.getCmsById(id, true);
    $('.page-contents').animate({ scrollLeft: $('#viewCmsStuiod').width() }, 400);
  }



  upgradeAzurePlan() {
    this.showAzureButtonloading = true;
    this.manageService.InitiateAzureUpgrade(this.tenantId).subscribe(initiateAzure => {
      this.showAzureButtonloading = false;
      if (initiateAzure == null) {
        this.cs.implementToast('Unable to upgrade to Azure plan, please contact Dicker Data customer support team', 'Error');
        this.azurePopup.close();
      } else if (initiateAzure.status === false) {
        this.cs.implementToast(initiateAzure.ResponseMessage, 'Error');
        this.azurePopup.close();
      } else if (initiateAzure.status === true) {
        this.cs.implementToast('Azure plan migration is in progress...', 'Info');
        this.isAzureUpgradeInProgress = true;
        this.showAzurePlan = false;
        this.azurePopup.close();
      }
    });
  }

  checkAzureUpgradeEligibility(content, event) {
    this.cs.implementToast('Verifying Azure plan eligibility', 'Info');
    this.showAzureButtonUpgradeloading = true;
    this.manageService.CheckAzureUpgradeEligibility(this.tenantId).subscribe(resEligibility => {
      this.showAzureButtonUpgradeloading = false;
      if (resEligibility === null) {
        this.cs.implementToast('This customer is not eligible for Azure plan upgrade', 'Error');
      } else if (resEligibility.status === false) {
        this.cs.implementToast(resEligibility.responseMessage, 'Error', this.azureUpgradeNotHiden);
      } else if (resEligibility.status === true) {
        this.open(content, event);
      }
    });
  }

  open(content, event) {
    event.preventDefault();
    event.stopPropagation();
    this.azurePopup = this.modalService.open(content, { centered: true });
    this.azurePopup.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  showNCECancellationButton(dateStr: string): boolean {
    const pruchase_date = new Date(dateStr);
    const last_cancel_date = addDays(pruchase_date, 3);
    const today = new Date;
    return isBefore(today, last_cancel_date);
  }

  cancelSubscription(subscription: GetCSPSubscription) {

    const purchase_date = new Date(subscription.out_process_datetime);

    const today = new Date;

    const diff = differenceInDays(today, purchase_date);

    let billing: number;

    // fully refund
    if (diff == 0) {

      billing = 0;

    } else {
      // partial refund
      const [term, ...rest] = subscription.out_stock_code.split(':');

      const daysInMonth = getDaysInMonth(today);

      if (term == 'P1M') {

        billing = (diff / daysInMonth) * Number(subscription.out_price) * Number(subscription.out_confirmed_qty);

      } else if (term == 'P1Y') {

        const monthlyPrice = Number(subscription.out_price) / 12;

        billing = (diff / daysInMonth) * monthlyPrice * Number(subscription.out_confirmed_qty);
      }

    }

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title: 'Confirm Cancellation', text: 'Are you sure to cancel this subscription?', billing: billing }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        subscription.cancelingNceSub = false;
        subscription.cancelingLoading = true;
        //this.showMpnIdloading = true;
        this.manageService.CancelSubscription(this.tenantId.toLocaleLowerCase(), subscription.out_subscription_id.toLocaleLowerCase(), subscription.out_stock_code.toLocaleLowerCase(), subscription.out_offer_uri.toLocaleLowerCase(), subscription.out_expiry_date).subscribe(() => {
          //this.showMpnIdloading = false;
          subscription.cancelingNceSub = true;
          subscription.cancelingLoading = false;
          this.refetchCSPItemsView();
        },
          (error: any) => {
            // this.showMpnIdloading = false;
            subscription.cancelingNceSub = false;
            subscription.cancelingLoading = false;
            this.cs.implementToast(error, "Error")
          });
      }
    });
  }

  updateSubscriptionAutoRenew(change: MatSlideToggleChange, subscription: GetCSPSubscription) {

    let action = change.checked ? 'on' : 'off';

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title: 'Confirm Auto-Renew Change', text: `Are you sure to turn ${action} Auto-renew?` }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.showMpnIdloading = true;
        this.manageService.UpdateSubscriptionRenew(this.tenantId.toLocaleLowerCase(), subscription.out_subscription_id.toLocaleLowerCase(), subscription.out_stock_code.toLocaleLowerCase(), change.checked, subscription.out_expiry_date).subscribe(
          () => {
            this.showMpnIdloading = false;
            this.cs.implementToast(`Auto-renew has been turned ${action} successfully`, "Success")
            this.refetchCSPItemsView();
          },
          (error: any) => {
            this.showMpnIdloading = false;
            this.cs.implementToast(error, "Error")
          }
        )
      } else {
        change.source.checked = !change.checked;
      }
    });
  }

  checkSubscriptionTermDuration(subscription: GetCSPSubscription): string {
    let term: string;
    if (subscription.out_target_term) {
      term = subscription.out_target_term;
    } else {
      term = subscription.out_stock_code.split(":")[0].toUpperCase();
    }
    return term;
  }

  getSubscriptionTermDuration(subscription: GetCSPSubscription): string {
    let term: string;
    if (subscription.out_target_term) {
      term = subscription.out_target_term;
    } else {
      term = subscription.out_stock_code.split(":")[0].toUpperCase();
    }
    if (term == 'P1M') {
      return 'Monthly';
    } else if (term == 'P1Y') {
      return 'Annual';
    }
    return 'Triennial';
  }

  refetchCSPItemsView(): void {
    this.subscriptionActions = [];
    this.originalBaseQty = [];
    this.originalAddonQty = [];
    this.originalBaseActive = [];
    this.originalAddonActive = [];
    this.subscriptionActions = [];
    this.annuityItemsPendingList = [];
    //this.addonListPendingList = [];

    this.hasSubPending = false;
    this.totalPriceChange = 0;
    this.pendingRowConfirmStatus = false;
    this.pendingTotal = 0;
    this.changeSubscriptionAmount = this.cs.toNumber(this.cs.readCookie('ChangeSubscriptionAmount'));
    this.isCSPItemLoading = true;
    this.manageService.GetCSPItemsView(this.tenantId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (model: CSPDetailsItemViewModel) => {
          this.activeTotal = '0';
          this.cSPDetailsItemViewModel = model;
          this.mpnList = model.mpnList;
          this.subscriptionActions = model.actions;
          this.nceRenewalPendingList = model.nceRenewalPendingList;
          this.manageService.setCurrentNCERenewalPendingList(this.nceRenewalPendingList)
          this.subscriptions = this.cSPDetailsItemViewModel.subscriptions;
          this.groupingSubscriptions();
          // tslint:disable-next-line:no-shadowed-variable
          let addonTemIndex = -1;
          this.hasLegacy = false;
          this.subscriptions.forEach((subscription: CSPSubscriptions, baseIndex: number) => {

            if (!this.hasLegacy && subscription?.baseSubscription?.out_charge_type == 'SEAT') {
              this.hasLegacy = true;
            }

            subscription.baseSubscription.cancelingNceSub = subscription.baseSubscription.out_status_desc == this.cancelDescText;
            subscription.baseSubscription.editMpnIdValue = subscription.baseSubscription.out_mpnid;
            subscription.baseSubscription.editMpnBool = false;
            subscription.baseSubscription.editDescValue = subscription.baseSubscription.out_sub_description;
            subscription.baseSubscription.editDescBool = false;
            subscription.baseSubscription.originalMpnId = subscription.baseSubscription.out_mpnid;
            subscription.baseSubscription.originalDesc = subscription.baseSubscription.out_sub_description;
            subscription.baseSubscription.out_pendingMessage = '';

            let originalBaseQtyPair = {} as KeyValuePair;
            originalBaseQtyPair.id = subscription.baseSubscription.out_subscription_id;
            originalBaseQtyPair.value = subscription.baseSubscription.out_qty;
            this.originalBaseQty.push(originalBaseQtyPair);

            subscription.baseSubscription.out_price_number = this.cs.toNumber(subscription.baseSubscription.out_price);

            let originalBaseActive = {} as KeyValuePair;
            originalBaseActive.id = subscription.baseSubscription.out_subscription_id;
            originalBaseActive.value = subscription.baseSubscription.out_status_desc == 'Active';
            this.originalBaseActive.push(originalBaseActive);

            if (subscription.baseSubscription.out_status_desc === 'Active') {
              subscription.baseSubscription.out_activeSuspend = true;
              //this.originalBaseActive.push(subscription.baseSubscription.out_activeSuspend);
              $(`#${subscription.baseSubscription.out_subscription_id} input[type="checkbox"]`).prop('checked', true);
              this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(subscription.baseSubscription.out_amount)).toString();
            } else {
              this.calculateTotalForNCE(subscription.baseSubscription);
              subscription.baseSubscription.out_activeSuspend = false;
              //this.originalBaseActive.push(subscription.baseSubscription.out_activeSuspend);
              $(`#${subscription.baseSubscription.out_subscription_id} input[type="checkbox"]`).prop('checked', false);

            }

            let originalAddOnQtyItem = {} as AddOnKeyValuePair;
            originalAddOnQtyItem.id = subscription.baseSubscription.out_subscription_id;
            let originalAddOnQtyList = [];

            let originalAddOnActiveItem = {} as AddOnKeyValuePair;
            originalAddOnActiveItem.id = subscription.baseSubscription.out_subscription_id;
            let originalAddOnActiveList = [];

            subscription.addOnSubscription.forEach((addOn) => {

              if (!this.hasLegacy && addOn?.out_charge_type == 'SEAT') {
                this.hasLegacy = true;
              }

              addOn.cancelingNceSub = addOn.out_status_desc == this.cancelDescText;
              addOn.out_pendingMessage = '';

              let originalAddOnQty = {} as KeyValuePair;
              originalAddOnQty.id = addOn.out_subscription_id;
              originalAddOnQty.value = addOn.out_qty;
              originalAddOnQtyList.push(originalAddOnQty);

              let originalAddOnActive = {} as KeyValuePair;
              originalAddOnActive.id = addOn.out_subscription_id;
              originalAddOnActive.value = addOn.out_status_desc == 'Active' && subscription.baseSubscription.out_status_desc == 'Active';
              originalAddOnActiveList.push(originalAddOnActive);

              addOn.out_price_number = this.cs.toNumber(addOn.out_price);
              if (addOn.out_status_desc === 'Active') {
                addOn.out_activeSuspend = true;
                $(`#${addOn.out_subscription_id} input[type="checkbox"]`).prop('checked', true);
                this.activeTotal = (this.cs.toNumber(this.activeTotal) + this.cs.toNumber(addOn.out_amount)).toString();
              } else {
                this.calculateTotalForNCE(addOn);
                addOn.out_activeSuspend = false;
                $(`#${addOn.out_subscription_id} input[type="checkbox"]`).prop('checked', false);
              }
            });

            originalAddOnQtyItem.value = originalAddOnQtyList;
            this.originalAddonQty.push(originalAddOnQtyItem);

            originalAddOnActiveItem.value = originalAddOnActiveList;
            this.originalAddonActive.push(originalAddOnActiveItem);

            if (this.subscriptionActions.length) {
              this.subscriptionActions.forEach(subscriptionAction => {
                if (!subscriptionAction.out_error_message) {
                  if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id) {
                    subscription.baseSubscription.out_status = subscriptionAction.out_status;
                    subscription.baseSubscription.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                    subscription.baseSubscription.out_action_status = true;
                    if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY') {
                      subscription.baseSubscription.out_activeSuspend = false;
                      subscription.baseSubscription.out_status = 'XX';
                    } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY') {
                      subscription.baseSubscription.out_activeSuspend = true;
                      //if (subscription.baseSubscription.out_activeSuspend === this.originalBaseActive[baseIndex]) {
                      if (subscription.baseSubscription.out_activeSuspend === originalBaseActive.value) {
                        subscription.baseSubscription.out_status = '';
                      } else {
                        subscription.baseSubscription.out_status = 'PR';
                      }
                    }
                  } else {
                    subscription.baseSubscription.out_action_status = false;
                  }
                  switch (subscriptionAction.out_key) {
                    case 'CREATE': { subscription.baseSubscription.out_pendingMessage = 'Pending Order Creation'; break; }
                    case 'QTY': { subscription.baseSubscription.out_pendingMessage = 'Pending Qty Change to ' + subscriptionAction.out_value; break; }
                    case 'MPNID': { subscription.baseSubscription.out_pendingMessage = 'Pending MPN ID Change to ' + subscriptionAction.out_value; break; }
                    case 'REF': { subscription.baseSubscription.out_pendingMessage = 'Pending Reference Change to ' + subscriptionAction.out_value; break; }
                    case 'SUSPEND':
                      {
                        subscription.baseSubscription.out_pendingMessage = 'Pending Suspension ';
                        break;
                      }
                    case 'REACTIVATE':
                      {
                        subscription.baseSubscription.out_pendingMessage = 'Pending Reactivation ';
                        break;
                      }
                  }
                }
              });
              subscription.addOnSubscription.forEach((addOn) => {
                addonTemIndex++;
                this.subscriptionActions.forEach(subscriptionAction => {
                  if (!subscriptionAction.out_error_message) {
                    if (subscription.baseSubscription.out_status !== 'XX' && subscriptionAction.out_subscription_id !== subscription.baseSubscription.out_subscription_id) {
                      if (subscriptionAction.out_subscription_id === addOn.out_subscription_id) {
                        addOn.out_status = subscriptionAction.out_status;
                        addOn.out_qty = this.cs.toNumber(subscriptionAction.out_qty).toString();
                        addOn.out_action_status = true;
                        if (subscription.baseSubscription.out_activeSuspend) {
                          if (subscriptionAction.out_status_desc === 'Active' && subscriptionAction.out_key !== 'QTY') {
                            addOn.out_activeSuspend = false;
                            addOn.out_status = 'XX';
                          } else if (subscriptionAction.out_status_desc !== 'Active' && subscriptionAction.out_key !== 'QTY') {
                            addOn.out_activeSuspend = true;
                            let originalAddOnActiveSuspendBase = this.originalAddonActive.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                            let originalAddOnActiveSuspend = originalAddOnActiveSuspendBase.value.find(x => x.id == addOn.out_subscription_id).value;

                            if (addOn.out_activeSuspend === originalAddOnActiveSuspend) {
                              addOn.out_status = '';
                            } else {
                              addOn.out_status = 'PR';
                            }
                          }
                        } else {
                          addOn.out_activeSuspend = false;
                          addOn.out_status = 'XX';
                        }
                      } else {
                        addOn.out_action_status = false;
                      }
                    } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscriptionAction.out_value === 'XX') {
                      addOn.out_status_desc = 'Pending Base Suspended';
                      addOn.out_activeSuspend = false;
                      $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                    } else if (subscriptionAction.out_subscription_id === subscription.baseSubscription.out_subscription_id && subscriptionAction.out_value !== 'XX') {
                      addOn.out_status_desc = 'Base Suspended';
                      addOn.out_activeSuspend = false;
                      $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                    } else {
                      addOn.out_status = 'XX';
                      addOn.out_activeSuspend = false;
                      addOn.out_status_desc = 'Base Pending Suspended';
                      $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                    }
                    switch (subscriptionAction.out_key) {
                      case 'CREATE': { addOn.out_pendingMessage = 'Pending Order Creation'; break; }
                      case 'QTY': { addOn.out_pendingMessage = 'Pending Qty Change to ' + subscriptionAction.out_value; break; }
                      case 'MPNID': { addOn.out_pendingMessage = 'Pending MPN ID Change to ' + subscriptionAction.out_value; break; }
                      case 'REF': { addOn.out_pendingMessage = 'Pending Reference Change to ' + subscriptionAction.out_value; break; }
                      case 'SUSPEND':
                        {
                          addOn.out_pendingMessage = 'Pending Suspension ';
                          break;
                        }
                      case 'REACTIVATE':
                        {
                          addOn.out_pendingMessage = 'Pending Reactivation ';
                          break;
                        }
                    }
                  }
                });
              });
            } else {
              subscription.baseSubscription.out_action_status = false;
              subscription.addOnSubscription.forEach(addOn => {
                addOn.out_action_status = false;
                if (subscription.baseSubscription.out_status === 'XX') {
                  addOn.out_status_desc = 'Base Suspended';
                  addOn.out_activeSuspend = false;
                  $(`#${addOn.out_subscription_id} .statustext`).html(`${addOn.out_status_desc}`);
                }
              });
            }
          });
          this.manageService.monitorExistingCSPSubscrptions([...this.subscriptions]);
        },
        complete: () => this.isCSPItemLoading = false
      });
  }

  getNCERenewalLabel(subscription: GetCSPSubscription): string {
    let term = '';
    if (subscription.out_target_term == 'P1M') {
      term = 'Monthly';
    } else if (subscription.out_target_term == 'P1Y') {
      term = 'Annual';
    } else if (subscription.out_target_term == 'P3Y') {
      term = 'Triennial ';
    };
    return `Renewal updated to ${term} will be effective on ${subscription.out_expiry_date}`;
  }

  promptBaseConfirm(event: any, subscription: CSPSubscriptions, index: number) {

    if (subscription.baseSubscription.out_activeSuspend) {

      const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
        width: '650px',
        data: { title: "Confirm Suspension", text: `This will suspend service, you will continue to accrue charges as per this subscriptions existing commitment. Additional commitments will also accrue if auto-renew is still enabled` }
      });

      dialogRef.afterClosed().subscribe((res) => {

        // subscription.out_activeSuspend = false;

        if (res) {

          subscription.baseSubscription.out_activeSuspend = !subscription.baseSubscription.out_activeSuspend;

          if (subscription.baseSubscription.out_activeSuspend == false) {
            //subscription.baseSubscription.out_activeSuspend = false;
            this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, 0);
            if (this.pendingRowConfirmStatus) {
              let originalBaseQtyItem = this.originalBaseQty.find(e => e.id == subscription.baseSubscription.out_subscription_id).value;
              subscription.baseSubscription.out_qty = originalBaseQtyItem;
              $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
              subscription.addOnSubscription.map((addon, idx) => {
                addon.out_activeSuspend = false;

                let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;

                addon.out_qty = originalAddOnQty;
                $(`#${addon.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
              });
            } else {
              $(`#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`).remove();
              $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
              subscription.addOnSubscription.map((addon, idx) => {
                addon.out_activeSuspend = false;

                let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;

                addon.out_qty = originalAddOnQty;
                $(`#${addon.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
              });
            }
          } else {
            // subscription.baseSubscription.out_activeSuspend = true;
            this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, 0);
            if (this.pendingRowConfirmStatus) {
              let originalBaseQtyItem = this.originalBaseQty.find(e => e.id == subscription.baseSubscription.out_subscription_id).value;
              subscription.baseSubscription.out_qty = originalBaseQtyItem;
              $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
              subscription.addOnSubscription.map((addon, idx) => {
                addon.out_activeSuspend = false;

                let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;

                addon.out_qty = originalAddOnQty;
                $(`#${addon.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
              });
            } else {
              $(`#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`).remove();
              $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
              subscription.addOnSubscription.map((addon, idx) => {

                let originalAddOnActiveSuspendBase = this.originalAddonActive.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                let originalAddOnActiveSuspend = originalAddOnActiveSuspendBase.value.find(x => x.id == addon.out_subscription_id).value;
                addon.out_activeSuspend = originalAddOnActiveSuspend;

                let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
                let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;
                addon.out_qty = originalAddOnQty;

                //addon.out_activeSuspend = this.originalAddonActive.filter(x => x.baseIndex === index)[idx].activeSuspend;
                //addon.out_qty = this.originalAddonQty.filter(x => x.baseIndex === index)[idx].qty;
                $(`#${addon.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
              });
            }
          }
          this.totalPriceChange = this.calculateTotalPriceChange();
          this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
          if (!this.pendingTotal) {
            this.totalPriceChange = 0;
          }

        } else {

        }

      })

      event.preventDefault();
    } else {

      subscription.baseSubscription.out_activeSuspend = true;

      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('base', subscription.baseSubscription, index, 0);
      if (this.pendingRowConfirmStatus) {
        let originalBaseQtyItem = this.originalBaseQty.find(e => e.id == subscription.baseSubscription.out_subscription_id).value;
        subscription.baseSubscription.out_qty = originalBaseQtyItem;
        $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;

          let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
          let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;

          addon.out_qty = originalAddOnQty;
          $(`#${addon.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
        });
      } else {
        $(`#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`).remove();
        $(`#${subscription.baseSubscription.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;

          let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.baseSubscription.out_subscription_id);
          let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == addon.out_subscription_id).value;

          addon.out_qty = originalAddOnQty;
          $(`#${addon.out_subscription_id} .statustext`).html(`${subscription.baseSubscription.out_status_desc}`);
        });
      }

      this.totalPriceChange = this.calculateTotalPriceChange();
      this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
      if (!this.pendingTotal) {
        this.totalPriceChange = 0;
      }

      event.preventDefault();
    }

  }

  promptAddonConfirm(event: any, subscription: GetCSPSubscription, index: number, addonIdx: number) {

    if (subscription.out_activeSuspend) {

      const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
        width: '650px',
        data: { title: "Confirm Suspension", text: `This will suspend service, you will continue to accrue charges as per this subscriptions existing commitment. Additional commitments will also accrue if auto-renew is still enabled` }
      });

      dialogRef.afterClosed().subscribe((res) => {

        // subscription.out_activeSuspend = false;

        if (res) {

          subscription.out_activeSuspend = !subscription.out_activeSuspend;

          if (subscription.out_activeSuspend == false) {
            //subscription.baseSubscription.out_activeSuspend = false;
            this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, index, addonIdx);
            if (this.pendingRowConfirmStatus) {

              let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.out_parent_subscription);
              let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == subscription.out_subscription_id).value;

              subscription.out_qty = originalAddOnQty;
              $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
            } else {
              $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
              $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
            }
          } else {
            // subscription.baseSubscription.out_activeSuspend = true;
            this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, index, addonIdx);
            if (this.pendingRowConfirmStatus) {

              let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.out_parent_subscription);
              let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == subscription.out_subscription_id).value;


              subscription.out_qty = originalAddOnQty;
              $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
            } else {
              $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
              $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
            }
          }
          this.totalPriceChange = this.calculateTotalPriceChange();
          this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
          if (!this.pendingTotal) {
            this.totalPriceChange = 0;
          }

        } else {

        }

      })

      event.preventDefault();
    } else {

      subscription.out_activeSuspend = true;

      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, index, addonIdx);
      if (this.pendingRowConfirmStatus) {

        let originalAddOnQtyBase = this.originalAddonQty.find(x => x.id == subscription.out_parent_subscription);
        let originalAddOnQty = originalAddOnQtyBase.value.find(x => x.id == subscription.out_subscription_id).value;

        subscription.out_qty = originalAddOnQty;
        $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
      } else {
        $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
        $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
      }

      this.totalPriceChange = this.calculateTotalPriceChange();
      this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
      if (!this.pendingTotal) {
        this.totalPriceChange = 0;
      }

      event.preventDefault();
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public getScheduledChange(subId: string): any {
    return this.nceRenewalPendingList.find(s => s.subscriptionId.toLocaleLowerCase() == subId.toLocaleLowerCase());
  }

  public exportExcel(): void {
    this.ngProgress.start();

    this.manageService
      .exportNCEMigrationReport(this.details.tenantId)
      .subscribe(
        (data: any) => {
          const fileName = `Migration Report ${this.details.tenantId}.xlsx`;

          this.fileService.saveAsExcelFile(data, fileName);
          this.ngProgress.done();
        },
        (error: any) => {
          console.error(error);
        }
      );
  }

  public openNCEMigrationPopup(): void {
    this.dialog.open(MigrateToNCEComponent, {
      width: '600px',
      data: { annuity: this.annuity }
    })
      .afterClosed()
      .subscribe(result => {
        if (result && result.action === 'CloseAndRefresh') {
          this.annuity.migrationInProgress = true;
        }
      });
  }

  public RITabClick() {
    if (!this.RITabOpened) {
      this.loadCSPCustomerEntitlments();
      this.RITabOpened = true
    }
  }

  public softwareTabClick() {
    if (!this.softwareTabOpened) {
      this.loadCSPSoftwareSubscriptionsView();
      this.softwareTabOpened = true
    }
  }

  public orderHistoryTabClick() {
    if (!this.orderHistoryTabOpened) {
      this.openGetOrderHistory()
    }
  }

  public applyOrderHistoryFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.orderHistoryTableDataSource.filter = filterValue.trim().toLowerCase();
  }

  public openGetOrderHistory() {
      this.orderHistoryTabOpened = true;
      this.loadOrderHistory();
  }
  private loadOrderHistory() {
    this.orderHistoryLoading = true;
    const startDate = this.datePipe.transform(new Date(Date.now() - 30 * this.orderHistoryPage * 24 * 60 * 60 * 1000), 'yyyy-MM-dd');
    const endDate = this.orderHistoryPage > 1 ? this.datePipe.transform(new Date(Date.now() - 30 * (this.orderHistoryPage - 1) * 24 * 60 * 60 * 1000), 'yyyy-MM-dd') : this.datePipe.transform(new Date(Date.now()), 'yyyy-MM-dd');
    const startDateDisplay = this.datePipe.transform(startDate, 'dd/MM/yyyy');
    this.orderHistoryDateFromText = ' FROM - ' + startDateDisplay
    this.manageService.getAMPOrdersByCustomer(this.tenantId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: IAMPOrdersByCustomerResponse[]) => {
          this.orderHistory = [...this.orderHistory, ...res];
          this.orderHistoryTableDataSource = new MatTableDataSource(this.orderHistory);
          this.appplyOrderHistoryFilter();
        },
        error: (err: string) => this.cs.implementToast(err, "Error"),
        complete: () => this.orderHistoryLoading = false
      });
  }

  private appplyOrderHistoryFilter() {
    this.orderHistoryTableDataSource.filterPredicate = (data: IAMPOrdersByCustomerResponse, filter: string) => {
      const filterValue = filter.toLowerCase();
      return this.datePipe.transform(data.creationDate, 'dd/MM/yyyy h:mm a').toLowerCase().includes(filterValue) ||
        data.orderType?.toLowerCase().includes(filterValue) ||
        data.offerId?.toLowerCase().includes(filterValue) ||
        data.stockDescription?.toLowerCase().includes(filterValue) ||
        data.quantity?.toString().toLowerCase().includes(filterValue);
    }
  }

  public orderHistoryLoadMore() {
    this.orderHistoryPage += 1;
    this.loadOrderHistory();
  }

  private loadCSPCustomerEntitlments() {
    this.cspReservedInstanceItems = [];
    this.loadCSPAzureri = false;
    this.manageService.GetCSPCustomerEntitlmentsView(this.tenantId)
      .subscribe((data: CSPCustomerEntitlementsViewModel[]) => {
        this.cspReservedInstanceItems = data.filter(element => element.entitlementType === 'reservedinstance');
        this.cs.applyScrollFixedHeader(this.parentWrapper);
        this.manageService.cspReservedInstanceItemsCount$.next(this.cspReservedInstanceItems.length);

        this.loadCSPAzureri = true;

      },
        (error: any) => {
          console.error(error);
          this.loadCSPAzureri = true;
        });
  }

  private loadCSPSoftwareSubscriptionsView() {
    this.cspSoftwareItems = [];
    this.loadCSPSoftware = false;
    this.manageService.GetCSPSoftwareSubscriptionsView(this.tenantId)
      .subscribe((data: CSPCustomerEntitlementsViewModel[]) => {
        this.cspSoftwareItems = data.filter(element => element.entitlementType === 'software');
        this.cs.applyScrollFixedHeader(this.parentWrapper);
        const urlArr = this.router.url.split("/");
        if (urlArr.length > 7 && urlArr[7].includes('sof')) {
          const [dummy, subId] = urlArr[7].split("=");
          let softwareSub = this.cspSoftwareItems.find(el => el.subscriptionId == subId)
          this.manageService.monitorCurrentCSPSoftware(softwareSub);
        }

        this.loadCSPSoftware = true;

      },
        (error: any) => {
          console.error(error);
          this.loadCSPSoftware = true;
        });
  }

  public getRRPTotal(s: CSPSubscriptions): number {
    const getRRP = this.convertPriceByTermAndBF(s?.baseSubscription?.out_stock_code, s?.baseSubscription?.out_rrp);
    return this.cs.toNumber(getRRP) * this.cs.toNumber(s?.baseSubscription?.out_qty);
  }

  private groupingSubscriptions(): void {
    this.nceSubs = this.subscriptions.filter(s => s?.baseSubscription?.out_stock_group !== '85CU' && ['NCE', 'TRIAL'].includes(s?.baseSubscription?.out_charge_type))
    this.nceSubsDataSource = new MatTableDataSource(this.nceSubs);
    this.licenseSubs = this.subscriptions.filter(s => s?.baseSubscription?.out_stock_group !== '85CU' && !['NCE', 'TRIAL'].includes(s?.baseSubscription?.out_charge_type))
    this.azureUsageSubs = this.subscriptions.filter(s => s.baseSubscription.out_stock_group === '85CU')
  }


  public nceSubTableSortChange(sortState: Sort) {
    if (!sortState.active || sortState.direction === '') {
      return;
    }

    const data = this.nceSubs.slice();
    this.nceSubsDataSource.data = data.sort((a, b) => {
      const isAsc = sortState.direction === 'asc';
      switch (sortState.active) {
        case 'desc':
          return this.compare(
            a.baseSubscription?.out_stock_code?.toLowerCase() || '',
            b.baseSubscription?.out_stock_code?.toLowerCase() || '',
            isAsc
          );
        case 'qty':
          return this.compare(
            Number(a.baseSubscription?.out_qty) || 0,
            Number(b.baseSubscription?.out_qty) || 0,
            isAsc
          );
        case 'autoRenewal':
          return this.compare(
            new Date(a?.baseSubscription?.out_expiry_date),
            new Date(b?.baseSubscription?.out_expiry_date),
            isAsc
          );
        case "status":
            return this.compare(a?.baseSubscription?.out_status_desc.toLowerCase(), b?.baseSubscription?.out_status_desc.toLowerCase(), isAsc);
        default:
          return 0;
      }
    });
  }

  private compare(a: any, b: any, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  private isInCustiomerMenu(): boolean {
    return this.router.url.includes('customer');
  }

  public convertPriceByTermAndBF(stockCode: string, price: string): string {
    const term = stockCode.split(':')[0];
    const billingFrequency = stockCode.split(':')[3];

    if (term == 'P3Y' && billingFrequency == '1') {
      return (this.cs.toNumber(price) / 36).toString();
    } else if (term == 'P3Y' && billingFrequency == 'Y') {
      return (this.cs.toNumber(price) / 3).toString();
    } else if (term == 'P1Y' && billingFrequency == '1') {
      return (this.cs.toNumber(price) / 12).toString();
    }
    return price;

  }

  public isRenewalInProgress(row: any): boolean {
    return row?.baseSubscription?.out_status_desc === 'Renewal In Progress';
  }

  public onMatChange() {
    const searchValue = this.searchSubscription.trim().toLowerCase();
    this.nceSubsDataSource.filterPredicate = (data: any, filter: string) => {
      return data.baseSubscription?.out_sub_description?.toLowerCase().includes(filter) ||
             data.baseSubscription?.out_stock_code?.toLowerCase().includes(filter) ||
             data.baseSubscription?.out_subscription_id?.toLowerCase().includes(filter) ||
             data.baseSubscription?.out_stk_description?.toLowerCase().includes(filter);
    };
    this.nceSubsDataSource.filter = searchValue;
  }

  public filterNCETableByStatus() {

    this.selectedRenewalOptions = '';
    if (this.selectedStatus.length === 0) {
      this.nceSubsDataSource.filter = '';
      return;
    }

    this.nceSubsDataSource.filterPredicate = (data: any, filter: string) => {
      const status = data.baseSubscription?.out_status_desc?.toLowerCase() || '';
      return this.selectedStatus.some(s => status.includes(s.toLowerCase()));
    };
    
    this.nceSubsDataSource.filter = 'active'; // Dummy filter value to trigger filtering
  }

  public filterNCETableByRenewalOptions() {
    this.selectedStatus = [];
    if (!this.selectedRenewalOptions) {
      this.nceSubsDataSource.filter = '';
      return;
    }

    this.nceSubsDataSource.filterPredicate = (data: any, filter: string) => {
      const autoRenew = data.baseSubscription?.out_auto_renew?.toLowerCase() || '';
      const subscriptionId = data.baseSubscription?.out_subscription_id;

      switch (this.selectedRenewalOptions) {
        case 'on':
          return autoRenew === 'true';
        case 'off':
          return autoRenew === 'false';
        case 'pending':
          return this.getScheduledChange(subscriptionId) ? true : false;
        default:
          return true;
      }
    };

    this.nceSubsDataSource.filter = 'dummy'; // Dummy filter value to trigger filtering
  }
}





